// GENERATED FILE, PLEASE DO NOT EDIT
var BackgroundPrimary = '#ffffff';
var BackgroundPrimaryInverted = '#1F2327';
var BackgroundSecondary = '#FAFAFA';
var BackgroundSecondaryInverted = '#2D3C48';
var BackgroundTertiary = '#EFF1F3';
var BackgroundElevated = '#ffffff';
var BackgroundOverlay = '#2D3C48';
var BackgroundSeparator = '#FAFAFA';
var BannerDefaultBackground = '#FAFAFA';
var BannerDefaultForeground = '#2D3C48';
var BannerDefaultIcon = '#2D3C48';
var BannerHighlightBackground = '#DEF1FA';
var BannerHighlightForeground = '#2D3C48';
var BannerHighlightIcon = '#009AD4';
var BannerInformationalBackground = '#2D3C48';
var BannerInformationalForeground = '#ffffff';
var BannerInformationalIcon = '#ffffff';
var BannerNegativeBackground = '#FFCCCC';
var BannerNegativeForeground = '#2D3C48';
var BannerNegativeIcon = '#D92B2B';
var BannerPositiveBackground = '#DFEFD9';
var BannerPositiveForeground = '#2D3C48';
var BannerPositiveIcon = '#24B324';
var BannerWarningBackground = '#FFF0C2';
var BannerWarningForeground = '#2D3C48';
var BannerWarningIcon = '#E5B82E';
var BannerHighlightDefaultBackground = '#DEF1FA';
var BannerHighlightDefaultForeground = '#2D3C48';
var BannerHighlightDefaultIcon = '#009AD4';
var BannerHighlightEmphasisBackground = '#0078A6';
var BannerHighlightEmphasisForeground = '#ffffff';
var BannerHighlightEmphasisIcon = '#ffffff';
var BannerInformationalDefaultBackground = '#FAFAFA';
var BannerInformationalDefaultForeground = '#2D3C48';
var BannerInformationalDefaultIcon = '#2D3C48';
var BannerInformationalEmphasisBackground = '#2D3C48';
var BannerInformationalEmphasisForeground = '#ffffff';
var BannerInformationalEmphasisIcon = '#ffffff';
var BannerNegativeDefaultBackground = '#FFCCCC';
var BannerNegativeDefaultForeground = '#2D3C48';
var BannerNegativeDefaultIcon = '#D92B2B';
var BannerNegativeEmphasisBackground = '#D92B2B';
var BannerNegativeEmphasisForeground = '#ffffff';
var BannerNegativeEmphasisIcon = '#ffffff';
var BannerPositiveDefaultBackground = '#DFEFD9';
var BannerPositiveDefaultForeground = '#2D3C48';
var BannerPositiveDefaultIcon = '#24B324';
var BannerPositiveEmphasisBackground = '#197D19';
var BannerPositiveEmphasisForeground = '#ffffff';
var BannerPositiveEmphasisIcon = '#ffffff';
var BannerWarningDefaultBackground = '#FFF0C2';
var BannerWarningDefaultForeground = '#2D3C48';
var BannerWarningDefaultIcon = '#E5B82E';
var BannerWarningEmphasisBackground = '#FFCC33';
var BannerWarningEmphasisForeground = '#101216';
var BannerWarningEmphasisIcon = '#101216';
var BannerInformationalSubduedBackground = '#ffffff';
var BannerInformationalSubduedBorder = '#EFF1F3';
var BannerInformationalSubduedDecorator = '#6E767E';
var BannerInformationalSubduedForeground = '#2D3C48';
var BannerInformationalSubduedIconBackground = '#FAFAFA';
var BannerInformationalSubduedIcon = '#26333D';
var BannerHighlightSubduedBackground = '#ffffff';
var BannerHighlightSubduedBorder = '#EFF1F3';
var BannerHighlightSubduedDecorator = '#00ACED';
var BannerHighlightSubduedForeground = '#2D3C48';
var BannerHighlightSubduedIconBackground = '#DEF1FA';
var BannerHighlightSubduedIcon = '#0089BD';
var BannerNegativeSubduedBackground = '#ffffff';
var BannerNegativeSubduedBorder = '#EFF1F3';
var BannerNegativeSubduedDecorator = '#D92B2B';
var BannerNegativeSubduedForeground = '#2D3C48';
var BannerNegativeSubduedIconBackground = '#FFCCCC';
var BannerNegativeSubduedIcon = '#C22626';
var BannerPositiveSubduedBackground = '#ffffff';
var BannerPositiveSubduedBorder = '#EFF1F3';
var BannerPositiveSubduedDecorator = '#24B324';
var BannerPositiveSubduedForeground = '#2D3C48';
var BannerPositiveSubduedIconBackground = '#DFEFD9';
var BannerPositiveSubduedIcon = '#1D8F1D';
var BannerWarningSubduedBackground = '#ffffff';
var BannerWarningSubduedBorder = '#EFF1F3';
var BannerWarningSubduedDecorator = '#FFCC33';
var BannerWarningSubduedForeground = '#2D3C48';
var BannerWarningSubduedIconBackground = '#FFF0C2';
var BannerWarningSubduedIcon = '#80661A';
var BorderPrimary = '#EFF1F3';
var BorderSecondary = '#CCD1D5';
var BorderFocus = '#00ACED';
var BorderError = '#D92B2B';
var BorderErrorDisabled = '#FFCCCC';
var ButtonDefaultToggleForegroundDisabled = '#6E767E';
var ButtonDefaultToggleForegroundOff = '#2D3C48';
var ButtonDefaultToggleForegroundOffDisabled = '#6E767E';
var ButtonDefaultToggleForegroundOffHovered = '#2D3C48';
var ButtonDefaultToggleForegroundOffPressed = '#2D3C48';
var ButtonDestructiveBackground = '#C22626';
var ButtonDestructiveBackgroundHovered = '#D92B2B';
var ButtonDestructiveBackgroundPressed = '#AD2222';
var ButtonDestructiveBackgroundDisabled = '#EFF1F3';
var ButtonDestructiveForeground = '#ffffff';
var ButtonDestructiveForegroundDisabled = '#6E767E';
var ButtonFabBackground = '#ffffff';
var ButtonFabBackgroundHovered = '#FAFAFA';
var ButtonFabBackgroundPressed = '#EFF1F3';
var ButtonFabForeground = '#2D3C48';
var ButtonFabForegroundHovered = '#2D3C48';
var ButtonFabForegroundPressed = '#2D3C48';
var ButtonFlatPrimaryForeground = '#F86932';
var ButtonFlatPrimaryForegroundDisabled = '#6E767E';
var ButtonFlatPrimaryForegroundHovered = '#DF5F2D';
var ButtonFlatPrimaryForegroundPressed = '#C65428';
var ButtonFlatSecondaryForeground = '#2D3C48';
var ButtonFlatSecondaryForegroundDisabled = '#6E767E';
var ButtonFlatSecondaryForegroundHovered = '#26333D';
var ButtonFlatSecondaryForegroundPressed = '#1F2327';
var ButtonLinkForeground = '#2D3C48';
var ButtonLinkForegroundHovered = '#4B5862';
var ButtonLinkForegroundPressed = '#6E767E';
var ButtonLinkForegroundDisabled = '#CCD1D5';
var ButtonPlainForeground = '#2D3C48';
var ButtonPlainForegroundDisabled = '#6E767E';
var ButtonPlainForegroundHovered = '#2D3C48';
var ButtonPlainForegroundPressed = '#2D3C48';
var ButtonPlainToggleForeground = '#2D3C48';
var ButtonPlainToggleForegroundDisabled = '#6E767E';
var ButtonPlainToggleForegroundHovered = '#2D3C48';
var ButtonPlainToggleForegroundOff = '#2D3C48';
var ButtonPlainToggleForegroundOffDisabled = '#6E767E';
var ButtonPlainToggleForegroundOffHovered = '#2D3C48';
var ButtonPlainToggleForegroundOffPressed = '#2D3C48';
var ButtonPlainToggleForegroundPressed = '#2D3C48';
var ButtonPrimaryBackground = '#F86932';
var ButtonPrimaryBackgroundDisabled = '#FAFAFA';
var ButtonPrimaryBackgroundHovered = '#DF5F2D';
var ButtonPrimaryBackgroundPressed = '#C65428';
var ButtonPrimaryForeground = '#ffffff';
var ButtonPrimaryForegroundDisabled = '#6E767E';
var ButtonPrimaryForegroundHovered = '#ffffff';
var ButtonPrimaryForegroundPressed = '#ffffff';
var ButtonPrimaryToggleBackground = '#2D3C48';
var ButtonPrimaryToggleBackgroundDisabled = '#CCD1D5';
var ButtonPrimaryToggleBackgroundHovered = '#4B5862';
var ButtonPrimaryToggleBackgroundPressed = '#26333D';
var ButtonPrimaryToggleBackgroundOff = '#EFF1F3';
var ButtonPrimaryToggleBackgroundOffDisabled = '#FAFAFA';
var ButtonPrimaryToggleBackgroundOffHovered = '#FAFAFA';
var ButtonPrimaryToggleBackgroundOffPressed = '#CCD1D5';
var ButtonPrimaryToggleBorderOff = '#EFF1F3';
var ButtonPrimaryToggleBorderOffHovered = '#FAFAFA';
var ButtonPrimaryToggleBorderOffPressed = '#CCD1D5';
var ButtonPrimaryToggleBorderOffDisabled = '#FAFAFA';
var ButtonPrimaryToggleBorderOn = '#2D3C48';
var ButtonPrimaryToggleBorderOnHovered = '#4B5862';
var ButtonPrimaryToggleBorderOnPressed = '#26333D';
var ButtonPrimaryToggleBorderOnDisabled = '#CCD1D5';
var ButtonPrimaryToggleForeground = '#ffffff';
var ButtonPrimaryToggleForegroundDisabled = '#6E767E';
var ButtonPrimaryToggleForegroundHovered = '#ffffff';
var ButtonPrimaryToggleForegroundPressed = '#ffffff';
var ButtonPrimaryToggleForegroundOff = '#2D3C48';
var ButtonPrimaryToggleForegroundOffDisabled = '#6E767E';
var ButtonPrimaryToggleForegroundOffHovered = '#2D3C48';
var ButtonPrimaryToggleForegroundOffPressed = '#2D3C48';
var ButtonSecondaryBackground = '#2D3C48';
var ButtonSecondaryBackgroundDisabled = '#FAFAFA';
var ButtonSecondaryBackgroundHovered = '#26333D';
var ButtonSecondaryBackgroundPressed = '#1F2327';
var ButtonSecondaryForeground = '#ffffff';
var ButtonSecondaryForegroundDisabled = '#6E767E';
var ButtonSecondaryForegroundHovered = '#ffffff';
var ButtonSecondaryForegroundPressed = '#ffffff';
var ButtonSecondaryToggleBackground = '#2D3C48';
var ButtonSecondaryToggleBackgroundDisabled = '#6E767E';
var ButtonSecondaryToggleBackgroundHovered = '#4B5862';
var ButtonSecondaryToggleBackgroundPressed = '#26333D';
var ButtonSecondaryToggleBackgroundOff = '#EFF1F3';
var ButtonSecondaryToggleBackgroundOffDisabled = '#FAFAFA';
var ButtonSecondaryToggleBackgroundOffHovered = '#FAFAFA';
var ButtonSecondaryToggleBackgroundOffPressed = '#CCD1D5';
var ButtonSecondaryToggleBorderOff = '#EFF1F3';
var ButtonSecondaryToggleBorderOffHovered = '#FAFAFA';
var ButtonSecondaryToggleBorderOffPressed = '#CCD1D5';
var ButtonSecondaryToggleBorderOffDisabled = '#FAFAFA';
var ButtonSecondaryToggleBorderOn = '#2D3C48';
var ButtonSecondaryToggleBorderOnHovered = '#4B5862';
var ButtonSecondaryToggleBorderOnPressed = '#26333D';
var ButtonSecondaryToggleBorderOnDisabled = '#CCD1D5';
var ButtonSecondaryToggleForeground = '#ffffff';
var ButtonSecondaryToggleForegroundDisabled = '#6E767E';
var ButtonSecondaryToggleForegroundHovered = '#ffffff';
var ButtonSecondaryToggleForegroundPressed = '#ffffff';
var ButtonSecondaryToggleForegroundOff = '#2D3C48';
var ButtonSecondaryToggleForegroundOffDisabled = '#6E767E';
var ButtonSecondaryToggleForegroundOffHovered = '#2D3C48';
var ButtonSecondaryToggleForegroundOffPressed = '#2D3C48';
var ButtonTertiaryBackground = '#EFF1F3';
var ButtonTertiaryBackgroundDisabled = '#FAFAFA';
var ButtonTertiaryBackgroundHovered = '#CCD1D5';
var ButtonTertiaryBackgroundPressed = '#6E767E';
var ButtonTertiaryBorder = '#EFF1F3';
var ButtonTertiaryBorderDisabled = '#FAFAFA';
var ButtonTertiaryBorderHovered = '#CCD1D5';
var ButtonTertiaryBorderPressed = '#6E767E';
var ButtonTertiaryForeground = '#2D3C48';
var ButtonTertiaryForegroundDisabled = '#6E767E';
var ButtonTertiaryForegroundHovered = '#2D3C48';
var ButtonTertiaryForegroundPressed = '#2D3C48';
var ButtonTertiaryToggleBackground = '#2D3C48';
var ButtonTertiaryToggleBackgroundDisabled = '#CCD1D5';
var ButtonTertiaryToggleBackgroundHovered = '#2D3C48';
var ButtonTertiaryToggleBackgroundPressed = '#26333D';
var ButtonTertiaryToggleBackgroundOff = '#EFF1F3';
var ButtonTertiaryToggleBackgroundOffDisabled = '#FAFAFA';
var ButtonTertiaryToggleBackgroundOffHovered = '#EFF1F3';
var ButtonTertiaryToggleBackgroundOffPressed = '#CCD1D5';
var ButtonTertiaryToggleBorderOff = '#EFF1F3';
var ButtonTertiaryToggleBorderOffHovered = '#EFF1F3';
var ButtonTertiaryToggleBorderOffPressed = '#CCD1D5';
var ButtonTertiaryToggleBorderOffDisabled = '#FAFAFA';
var ButtonTertiaryToggleBorderOn = '#2D3C48';
var ButtonTertiaryToggleBorderOnHovered = '#2D3C48';
var ButtonTertiaryToggleBorderOnPressed = '#26333D';
var ButtonTertiaryToggleBorderOnDisabled = '#CCD1D5';
var ButtonTertiaryToggleForeground = '#ffffff';
var ButtonTertiaryToggleForegroundDisabled = '#6E767E';
var ButtonTertiaryToggleForegroundHovered = '#CCD1D5';
var ButtonTertiaryToggleForegroundPressed = '#ffffff';
var ButtonTertiaryToggleForegroundOff = '#2D3C48';
var ButtonTertiaryToggleForegroundOffDisabled = '#CCD1D5';
var ButtonTertiaryToggleForegroundOffHovered = '#1F2327';
var ButtonTertiaryToggleForegroundOffPressed = '#1F2327';
var ButtonPrimaryToggleGroupBackgroundOff = '#EFF1F3';
var ButtonPrimaryToggleGroupBackgroundOffHovered = '#EFF1F3';
var ButtonPrimaryToggleGroupBackgroundOffPressed = '#CCD1D5';
var ButtonPrimaryToggleGroupBackgroundOffDisabled = '#FAFAFA';
var ButtonPrimaryToggleGroupBorderOff = '#EFF1F3';
var ButtonPrimaryToggleGroupBorderOffHovered = '#EFF1F3';
var ButtonPrimaryToggleGroupBorderOffPressed = '#CCD1D5';
var ButtonPrimaryToggleGroupBorderOffDisabled = '#FAFAFA';
var ButtonPrimaryToggleGroupForegroundOff = '#2D3C48';
var ButtonPrimaryToggleGroupForegroundOffHovered = '#1F2327';
var ButtonPrimaryToggleGroupForegroundOffPressed = '#1F2327';
var ButtonPrimaryToggleGroupForegroundOffDisabled = '#CCD1D5';
var ButtonPrimaryToggleGroupBackgroundOn = '#2D3C48';
var ButtonPrimaryToggleGroupBackgroundOnHovered = '#2D3C48';
var ButtonPrimaryToggleGroupBackgroundOnPressed = '#26333D';
var ButtonPrimaryToggleGroupBackgroundOnDisabled = '#CCD1D5';
var ButtonPrimaryToggleGroupBorderOn = '#101216';
var ButtonPrimaryToggleGroupBorderOnHovered = '#26333D';
var ButtonPrimaryToggleGroupBorderOnPressed = '#1F2327';
var ButtonPrimaryToggleGroupBorderOnDisabled = '#FAFAFA';
var ButtonPrimaryToggleGroupForegroundOnDisabled = '#6E767E';
var ButtonSecondaryToggleGroupBackgroundOff = '#EFF1F3';
var ButtonSecondaryToggleGroupBackgroundOffHovered = '#EFF1F3';
var ButtonSecondaryToggleGroupBackgroundOffPressed = '#CCD1D5';
var ButtonSecondaryToggleGroupBackgroundOffDisabled = '#FAFAFA';
var ButtonSecondaryToggleGroupBorderOff = '#EFF1F3';
var ButtonSecondaryToggleGroupBorderOffHovered = '#EFF1F3';
var ButtonSecondaryToggleGroupBorderOffPressed = '#CCD1D5';
var ButtonSecondaryToggleGroupBorderOffDisabled = '#FAFAFA';
var ButtonSecondaryToggleGroupForegroundOff = '#2D3C48';
var ButtonSecondaryToggleGroupForegroundOffHovered = '#1F2327';
var ButtonSecondaryToggleGroupForegroundOffPressed = '#1F2327';
var ButtonSecondaryToggleGroupForegroundOffDisabled = '#CCD1D5';
var ButtonSecondaryToggleGroupBackgroundOn = '#2D3C48';
var ButtonSecondaryToggleGroupBackgroundOnHovered = '#2D3C48';
var ButtonSecondaryToggleGroupBackgroundOnPressed = '#26333D';
var ButtonSecondaryToggleGroupBackgroundOnDisabled = '#CCD1D5';
var ButtonSecondaryToggleGroupBorderOn = '#101216';
var ButtonSecondaryToggleGroupBorderOnHovered = '#26333D';
var ButtonSecondaryToggleGroupBorderOnPressed = '#1F2327';
var ButtonSecondaryToggleGroupBorderOnDisabled = '#FAFAFA';
var ButtonSecondaryToggleGroupForegroundOnDisabled = '#6E767E';
var ButtonTertiaryToggleGroupBackgroundOff = '#EFF1F3';
var ButtonTertiaryToggleGroupBackgroundOffHovered = '#EFF1F3';
var ButtonTertiaryToggleGroupBackgroundOffPressed = '#CCD1D5';
var ButtonTertiaryToggleGroupBackgroundOffDisabled = '#FAFAFA';
var ButtonTertiaryToggleGroupBorderOff = '#EFF1F3';
var ButtonTertiaryToggleGroupBorderOffHovered = '#EFF1F3';
var ButtonTertiaryToggleGroupBorderOffPressed = '#CCD1D5';
var ButtonTertiaryToggleGroupBorderOffDisabled = '#FAFAFA';
var ButtonTertiaryToggleGroupForegroundOff = '#2D3C48';
var ButtonTertiaryToggleGroupForegroundOffHovered = '#1F2327';
var ButtonTertiaryToggleGroupForegroundOffPressed = '#1F2327';
var ButtonTertiaryToggleGroupForegroundOffDisabled = '#CCD1D5';
var ButtonTertiaryToggleGroupBackgroundOn = '#2D3C48';
var ButtonTertiaryToggleGroupBackgroundOnHovered = '#2D3C48';
var ButtonTertiaryToggleGroupBackgroundOnPressed = '#26333D';
var ButtonTertiaryToggleGroupBackgroundOnDisabled = '#CCD1D5';
var ButtonTertiaryToggleGroupBorderOn = '#2D3C48';
var ButtonTertiaryToggleGroupBorderOnHovered = '#2D3C48';
var ButtonTertiaryToggleGroupBorderOnPressed = '#26333D';
var ButtonTertiaryToggleGroupBorderOnDisabled = '#CCD1D5';
var ButtonTertiaryToggleGroupForegroundOn = '#ffffff';
var ButtonTertiaryToggleGroupForegroundOnHovered = '#CCD1D5';
var ButtonTertiaryToggleGroupForegroundOnPressed = '#ffffff';
var ButtonTertiaryToggleGroupForegroundOnDisabled = '#6E767E';
var ButtonFloatingToggleGroupBackgroundColorOff = '#EFF1F3';
var ButtonTabBackgroundOffDefault = '#ffffff';
var ButtonTabBackgroundOffHovered = '#FAFAFA';
var ButtonTabBackgroundOffPressed = '#EFF1F3';
var ButtonTabBackgroundOffDisabled = '#ffffff';
var ButtonTabBackgroundOnDefault = '#ffffff';
var ButtonTabBackgroundOnHovered = '#FAFAFA';
var ButtonTabBackgroundOnPressed = '#EFF1F3';
var ButtonTabBackgroundOnDisabled = '#ffffff';
var ButtonTabForegroundOffDefault = '#4B5862';
var ButtonTabForegroundOffHovered = '#4B5862';
var ButtonTabForegroundOffPressed = '#4B5862';
var ButtonTabForegroundOffDisabled = '#CCD1D5';
var ButtonTabForegroundOnDefault = '#2D3C48';
var ButtonTabForegroundOnHovered = '#2D3C48';
var ButtonTabForegroundOnPressed = '#2D3C48';
var ButtonTabForegroundOnDisabled = '#CCD1D5';
var CardBackgroundDefault = '#ffffff';
var CardBackgroundHovered = '#ffffff';
var CardBackgroundPressed = '#ffffff';
var CardBackgroundDisabled = '#ffffff';
var CardBorderUnselectedDefault = '#EFF1F3';
var CardBorderUnselectedHovered = '#CCD1D5';
var CardBorderUnselectedPressed = '#6E767E';
var CardBorderUnselectedDisabled = '#FAFAFA';
var CardBorderUnselectedError = '#D92B2B';
var CardBorderUnselectedErrorDisabled = '#FFCCCC';
var CardBorderSelectedDefault = '#2D3C48';
var CardBorderSelectedHovered = '#4B5862';
var CardBorderSelectedPressed = '#6E767E';
var CardBorderSelectedDisabled = '#CCD1D5';
var CardBorderSelectedError = '#D92B2B';
var CardBorderSelectedErrorDisabled = '#FFCCCC';
var CardTitleDefault = '#2D3C48';
var CardTitleHovered = '#4B5862';
var CardTitlePressed = '#6E767E';
var CardTitleDisabled = '#CCD1D5';
var CardBodyDefault = '#4B5862';
var CardBodyHovered = '#6E767E';
var CardBodyPressed = '#6E767E';
var CardBodyDisabled = '#CCD1D5';
var ChatIncomingBackground = '#FAFAFA';
var ChatIncomingForeground = '#2D3C48';
var ChatOutgoingBackground = '#2D3C48';
var ChatOutgoingForeground = '#ffffff';
var DatePickerDateUnselectedBackground = '#ffffff';
var DatePickerDateUnselectedBackgroundHovered = '#FAFAFA';
var DatePickerDateUnselectedBackgroundPressed = '#EFF1F3';
var DatePickerDateUnselectedBackgroundDisabled = '#ffffff';
var DatePickerDateBorderUnselected = '#ffffff';
var DatePickerDateBorderUnselectedHovered = '#FAFAFA';
var DatePickerDateBorderUnselectedPressed = '#EFF1F3';
var DatePickerDateBorderUnselectedDisabled = '#ffffff';
var DatePickerDateForegroundUnselected = '#1F2327';
var DatePickerDateForegroundUnselectedHovered = '#1F2327';
var DatePickerDateForegroundUnselectedPressed = '#1F2327';
var DatePickerDateForegroundUnselectedDisabled = '#CCD1D5';
var DatePickerDateSelectedBackground = '#1F2327';
var DatePickerDateSelectedBackgroundHovered = '#2D3C48';
var DatePickerDateSelectedBackgroundPressed = '#26333D';
var DatePickerDateSelectedBackgroundDisabled = '#EFF1F3';
var DatePickerDateBorderSelected = '#1F2327';
var DatePickerDateBorderSelectedHovered = '#2D3C48';
var DatePickerDateBorderSelectedPressed = '#26333D';
var DatePickerDateBorderSelectedDisabled = '#EFF1F3';
var DatePickerDateForegroundSelected = '#ffffff';
var DatePickerDateForegroundSelectedHovered = '#ffffff';
var DatePickerDateForegroundSelectedPressed = '#ffffff';
var DatePickerDateForegroundSelectedDisabled = '#6E767E';
var DatePickerRangeUnselectedBackground = '#ffffff';
var DatePickerRangeUnselectedBackgroundHovered = '#FAFAFA';
var DatePickerRangeUnselectedBackgroundPressed = '#EFF1F3';
var DatePickerRangeUnselectedBackgroundDisabled = '#ffffff';
var DatePickerRangeBorderUnselected = '#ffffff';
var DatePickerRangeBorderUnselectedHovered = '#FAFAFA';
var DatePickerRangeBorderUnselectedPressed = '#EFF1F3';
var DatePickerRangeBorderUnselectedDisabled = '#ffffff';
var DatePickerRangeForegroundUnselected = '#1F2327';
var DatePickerRangeForegroundUnselectedHovered = '#1F2327';
var DatePickerRangeForegroundUnselectedPressed = '#1F2327';
var DatePickerRangeForegroundUnselectedDisabled = '#CCD1D5';
var DatePickerRangeSelectedBackground = '#EFF1F3';
var DatePickerRangeSelectedBackgroundHovered = '#CCD1D5';
var DatePickerRangeSelectedBackgroundPressed = '#6E767E';
var DatePickerRangeSelectedBackgroundDisabled = '#ffffff';
var DatePickerRangeBorderSelected = '#EFF1F3';
var DatePickerRangeBorderSelectedHovered = '#CCD1D5';
var DatePickerRangeBorderSelectedPressed = '#6E767E';
var DatePickerRangeBorderSelectedDisabled = '#ffffff';
var DatePickerRangeForegroundSelected = '#1F2327';
var DatePickerRangeForegroundSelectedHovered = '#1F2327';
var DatePickerRangeForegroundSelectedPressed = '#1F2327';
var DatePickerRangeForegroundSelectedDisabled = '#CCD1D5';
var DatePickerTodayBorderSelected = '#4B5862';
var DatePickerDateUnselectedIndicatorPrimary = '#AE4A23';
var DatePickerDateUnselectedIndicatorSecondary = '#4B5862';
var DatePickerDateUnselectedIndicatorDisabled = '#CCD1D5';
var DatePickerDateSelectedIndicatorPrimary = '#FDC7B3';
var DatePickerDateSelectedIndicatorSecondary = '#CCD1D5';
var DatePickerDateSelectedIndicatorDisabled = '#6E767E';
var DatePickerRangeSelectedIndicatorPrimary = '#AE4A23';
var DatePickerRangeSelectedIndicatorSecondary = '#4B5862';
var DatePickerRangeSelectedIndicatorDisabled = '#CCD1D5';
var FieldsBackgroundActive = '#FAFAFA';
var FieldsBackgroundDisabled = '#FAFAFA';
var FieldsBackgroundError = '#FFCCCC';
var FieldsBackgroundInactive = '#FAFAFA';
var FieldsBorderActive = '#2D3C48';
var FieldsBorderDisabled = '#FAFAFA';
var FieldsBorderError = '#C22626';
var FieldsBorderInactive = '#FAFAFA';
var FieldsForegroundActive = '#2D3C48';
var FieldsForegroundDisabled = '#CCD1D5';
var FieldsForegroundError = '#2D3C48';
var FieldsForegroundInactive = '#2D3C48';
var FieldsForegroundPlaceholder = '#6E767E';
var FieldsIconDropdown = '#2D3C48';
var FieldsIconSearch = '#2D3C48';
var FieldsInputBackgroundDisabled = '#FAFAFA';
var FieldsInputBorder = '#CCD1D5';
var FieldsInputBorderError = '#AD2222';
var GlobalPrimary = '#F86932';
var GlobalSecondary = '#24B324';
var ListCellContainerBackgroundDefault = '#ffffff';
var ListCellContainerBackgroundHovered = '#EFF1F3';
var ListCellContainerBackgroundPressed = '#CCD1D5';
var ListCellContainerBackgroundUnread = '#DEF1FA';
var ListCellContainerBackgroundUnreadHovered = '#DEF1FA';
var ListCellContainerBackgroundUnreadPressed = '#00ACED';
var ListCellIconToggledOn = '#F86932';
var ListCellIconToggledOff = '#6E767E';
var LoadingDefault = '#F86932';
var MenuItemBackground = '#ffffff';
var MenuItemBackgroundHovered = '#EFF1F3';
var MenuItemBackgroundPressed = '#CCD1D5';
var MenuItemBackgroundDisabled = '#ffffff';
var MenuItemForeground = '#2D3C48';
var MenuItemForegroundHovered = '#2D3C48';
var MenuItemForegroundPressed = '#2D3C48';
var MenuItemForegroundDisabled = '#CCD1D5';
var OverlayBackgroundDefault = '#2D3C48';
var OverlayLoadingDefault = '#F86932';
var PageBackgroundSecondary = '#FAFAFA';
var PageBackgroundTertiary = '#EFF1F3';
var PaginationNumberedSelectedBackground = '#2D3C48';
var PaginationNumberedSelectedBackgroundDisabled = '#CCD1D5';
var PaginationNumberedSelectedBackgroundHovered = '#2D3C48';
var PaginationNumberedSelectedBackgroundPressed = '#26333D';
var PaginationNumberedSelectedBorder = '#2D3C48';
var PaginationNumberedSelectedBorderDisabled = '#CCD1D5';
var PaginationNumberedSelectedBorderHovered = '#2D3C48';
var PaginationNumberedSelectedBorderPressed = '#26333D';
var PaginationNumberedSelectedForeground = '#ffffff';
var PaginationNumberedSelectedForegroundDisabled = '#6E767E';
var PaginationNumberedSelectedForegroundHovered = '#ffffff';
var PaginationNumberedSelectedForegroundPressed = '#ffffff';
var PaginationNumberedUnselectedBackground = '#EFF1F3';
var PaginationNumberedUnselectedBackgroundDisabled = '#FAFAFA';
var PaginationNumberedUnselectedBackgroundHovered = '#EFF1F3';
var PaginationNumberedUnselectedBackgroundPressed = '#CCD1D5';
var PaginationNumberedUnselectedBorder = '#EFF1F3';
var PaginationNumberedUnselectedBorderDisabled = '#FAFAFA';
var PaginationNumberedUnselectedBorderHovered = '#EFF1F3';
var PaginationNumberedUnselectedBorderPressed = '#CCD1D5';
var PaginationNumberedUnselectedForeground = '#2D3C48';
var PaginationNumberedUnselectedForegroundDisabled = '#CCD1D5';
var PaginationNumberedUnselectedForegroundHovered = '#2D3C48';
var PaginationNumberedUnselectedForegroundPressed = '#2D3C48';
var PaginationSelectedDark = '#6E767E';
var PaginationSelectedPrimary = '#F86932';
var PaginationSelectedLight = '#ffffff';
var PaginationUnselectedDark = '#CCD1D5';
var PaginationUnselectedPrimary = '#CCD1D5';
var PaginationUnselectedLight = '#EFF1F3';
var SliderKnobBackground = '#4B5862';
var SliderKnobBackgroundHovered = '#2D3C48';
var SliderKnobBackgroundPressed = '#26333D';
var SliderKnobBackgroundDisabled = '#CCD1D5';
var SliderTrackBackgroundOff = '#CCD1D5';
var SliderTrackBackgroundOffDisabled = '#EFF1F3';
var SliderTrackBackgroundOn = '#4B5862';
var SliderTrackBackgroundOnDisabled = '#CCD1D5';
var SliderTextOff = '#6E767E';
var SliderTextOn = '#4B5862';
var SliderTextOnDisabled = '#CCD1D5';
var SliderTextOffDisabled = '#EFF1F3';
var SliderIcon = '#4B5862';
var SliderIconDisabled = '#CCD1D5';
var QuantityStepperFloatingCollapsedSelectedBackgroundDefault = '#2D3C48';
var QuantityStepperFloatingCollapsedSelectedBackgroundHover = '#26333D';
var QuantityStepperFloatingCollapsedSelectedBackgroundPressed = '#1F2327';
var QuantityStepperFloatingCollapsedSelectedBackgroundDisabled = '#EFF1F3';
var QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDefault = '#ffffff';
var QuantityStepperFloatingCollapsedSelectedForegroundPrimaryHover = '#ffffff';
var QuantityStepperFloatingCollapsedSelectedForegroundPrimaryPressed = '#ffffff';
var QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDisabled = '#6E767E';
var QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDefault = '#EFF1F3';
var QuantityStepperFloatingCollapsedSelectedForegroundSecondaryHover = '#EFF1F3';
var QuantityStepperFloatingCollapsedSelectedForegroundSecondaryPressed = '#EFF1F3';
var QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDisabled = '#6E767E';
var QuantityStepperFloatingCollapsedUnselectedBackgroundDefault = '#ffffff';
var QuantityStepperFloatingCollapsedUnselectedBackgroundHover = '#FAFAFA';
var QuantityStepperFloatingCollapsedUnselectedBackgroundPressed = '#EFF1F3';
var QuantityStepperFloatingCollapsedUnselectedBackgroundDisabled = '#EFF1F3';
var QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDefault = '#2D3C48';
var QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryHover = '#2D3C48';
var QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryPressed = '#2D3C48';
var QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDisabled = '#6E767E';
var QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDefault = '#4B5862';
var QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryHover = '#4B5862';
var QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryPressed = '#4B5862';
var QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDisabled = '#6E767E';
var QuantityStepperFloatingExpandedBackgroundDefault = '#ffffff';
var QuantityStepperFloatingExpandedBackgroundHover = '#FAFAFA';
var QuantityStepperFloatingExpandedBackgroundPressed = '#EFF1F3';
var QuantityStepperFloatingExpandedBackgroundDisabled = '#EFF1F3';
var QuantityStepperFloatingExpandedForegroundPrimaryDefault = '#2D3C48';
var QuantityStepperFloatingExpandedForegroundPrimaryHover = '#2D3C48';
var QuantityStepperFloatingExpandedForegroundPrimaryPressed = '#2D3C48';
var QuantityStepperFloatingExpandedForegroundPrimaryDisabled = '#6E767E';
var QuantityStepperFloatingExpandedForegroundSecondaryDefault = '#4B5862';
var QuantityStepperFloatingExpandedForegroundSecondaryHover = '#4B5862';
var QuantityStepperFloatingExpandedForegroundSecondaryPressed = '#4B5862';
var QuantityStepperFloatingExpandedForegroundSecondaryDisabled = '#6E767E';
var SwitchBackgroundOn = '#2D3C48';
var SwitchBackgroundOnDisabled = '#CCD1D5';
var SwitchBackgroundOff = '#6E767E';
var SwitchBackgroundOffDisabled = '#CCD1D5';
var SwitchBorderOn = '#2D3C48';
var SwitchBorderOnDisabled = '#CCD1D5';
var SwitchBorderOff = '#6E767E';
var SwitchBorderOffDisabled = '#CCD1D5';
var SwitchForegroundOn = '#ffffff';
var SwitchForegroundOnDisabled = '#FAFAFA';
var SwitchForegroundOff = '#ffffff';
var SwitchForegroundOffDisabled = '#FAFAFA';
var SwitchTrackOff = '#6E767E';
var SwitchTrackOffDisabled = '#CCD1D5';
var SwitchThumbOff = '#ffffff';
var SwitchThumbOffDisabled = '#FAFAFA';
var SwitchTrackOn = '#6E767E';
var SwitchTrackOnDisabled = '#CCD1D5';
var SwitchThumbOn = '#2D3C48';
var SwitchThumbOnDisabled = '#6E767E';
var TagDefaultBackground = '#EFF1F3';
var TagDefaultBorder = '#EFF1F3';
var TagDefaultForeground = '#2D3C48';
var TagDefaultIcon = '#2D3C48';
var TagHighlightBackground = '#DEF1FA';
var TagHighlightBorder = '#DEF1FA';
var TagHighlightForeground = '#00678E';
var TagHighlightIcon = '#00678E';
var TagInformationalBackground = '#4B5862';
var TagInformationalBorder = '#4B5862';
var TagInformationalForeground = '#ffffff';
var TagInformationalIcon = '#ffffff';
var TagNegativeBackground = '#FFCCCC';
var TagNegativeBorder = '#FFCCCC';
var TagNegativeForeground = '#821A1A';
var TagNegativeIcon = '#821A1A';
var TagPositiveBackground = '#DFEFD9';
var TagPositiveBorder = '#DFEFD9';
var TagPositiveForeground = '#166B16';
var TagPositiveIcon = '#166B16';
var TagWarningBackground = '#FFF0C2';
var TagWarningBorder = '#FFF0C2';
var TagWarningForeground = '#665214';
var TagWarningIcon = '#665214';
var TagInformationalDefaultBackground = '#EFF1F3';
var TagInformationalDefaultBorder = '#EFF1F3';
var TagInformationalDefaultForeground = '#2D3C48';
var TagInformationalDefaultIcon = '#2D3C48';
var TagInformationalEmphasisBackground = '#4B5862';
var TagInformationalEmphasisBorder = '#4B5862';
var TagInformationalEmphasisForeground = '#ffffff';
var TagInformationalEmphasisIcon = '#ffffff';
var TagNegativeDefaultBackground = '#FFCCCC';
var TagNegativeDefaultBorder = '#FFCCCC';
var TagNegativeDefaultForeground = '#821A1A';
var TagNegativeDefaultIcon = '#821A1A';
var TagNegativeEmphasisBackground = '#D92B2B';
var TagNegativeEmphasisBorder = '#D92B2B';
var TagNegativeEmphasisForeground = '#ffffff';
var TagNegativeEmphasisIcon = '#ffffff';
var TagPositiveDefaultBackground = '#DFEFD9';
var TagPositiveDefaultBorder = '#DFEFD9';
var TagPositiveDefaultForeground = '#166B16';
var TagPositiveDefaultIcon = '#166B16';
var TagPositiveEmphasisBackground = '#24B324';
var TagPositiveEmphasisBorder = '#24B324';
var TagPositiveEmphasisForeground = '#ffffff';
var TagPositiveEmphasisIcon = '#ffffff';
var TagWarningDefaultBackground = '#FFF0C2';
var TagWarningDefaultBorder = '#FFF0C2';
var TagWarningDefaultForeground = '#665214';
var TagWarningDefaultIcon = '#665214';
var TagWarningEmphasisBackground = '#FFCC33';
var TagWarningEmphasisBorder = '#FFCC33';
var TagWarningEmphasisForeground = '#2D3C48';
var TagWarningEmphasisIcon = '#2D3C48';
var TagHighlightDefaultBackground = '#DEF1FA';
var TagHighlightDefaultBorder = '#DEF1FA';
var TagHighlightDefaultForeground = '#00678E';
var TagHighlightDefaultIcon = '#00678E';
var TagHighlightEmphasisBackground = '#00ACED';
var TagHighlightEmphasisBorder = '#00ACED';
var TagHighlightEmphasisForeground = '#ffffff';
var TagHighlightEmphasisIcon = '#ffffff';
var TagInformationalSubduedBackground = '#ffffff';
var TagInformationalSubduedBorder = '#CCD1D5';
var TagInformationalSubduedForeground = '#6E767E';
var TagInformationalSubduedIcon = '#6E767E';
var TagNegativeSubduedBackground = '#ffffff';
var TagNegativeSubduedBorder = '#CCD1D5';
var TagNegativeSubduedForeground = '#D92B2B';
var TagNegativeSubduedIcon = '#D92B2B';
var TagPositiveSubduedBackground = '#ffffff';
var TagPositiveSubduedBorder = '#CCD1D5';
var TagPositiveSubduedForeground = '#197D19';
var TagPositiveSubduedIcon = '#197D19';
var TagWarningSubduedBackground = '#ffffff';
var TagWarningSubduedBorder = '#CCD1D5';
var TagWarningSubduedForeground = '#80661A';
var TagWarningSubduedIcon = '#80661A';
var TagHighlightSubduedBackground = '#ffffff';
var TagHighlightSubduedBorder = '#CCD1D5';
var TagHighlightSubduedForeground = '#0078A6';
var TagHighlightSubduedIcon = '#0078A6';
var TextAccentedPrimary = '#F86932';
var TextAccentedSecondary = '#00ACED';
var TextAction = '#F86932';
var TextCallout = '#F86932';
var TextDisabled = '#CCD1D5';
var TextError = '#D92B2B';
var TextHighlight = '#00ACED';
var TextPositive = '#20A120';
var TextPrimary = '#2D3C48';
var TextPrimaryOnDark = '#ffffff';
var TextSecondary = '#4B5862';
var TextSecondaryOnDark = '#EFF1F3';
var TextSelected = '#F86932';
var TextTertiary = '#6E767E';
var TextTooltip = '#6E767E';
var TextWarning = '#E5B82E';
var TimelineTrackBackgroundOff = '#EFF1F3';
var TimelineTrackBackgroundOn = '#2D3C48';
var TimelineTrackForegroundOff = '#2D3C48';
var TimelineTrackForegroundOn = '#ffffff';
var TimelineTrackShimmer = '#4B5862';
var ToastInformationalBackground = '#4B5862';
var ToastInformationalForeground = '#EFF1F3';
var ToastInformationalAction = '#ffffff';
var ToastInformationalActionPressed = '#CCD1D5';
var ToastInformationalActionHovered = '#EFF1F3';
var ToastInformationalActionDisabled = '#6E767E';
var ToggleBackgroundOn = '#2D3C48';
var ToggleBackgroundOnDisabled = '#CCD1D5';
var ToggleBackgroundOff = '#ffffff';
var ToggleBackgroundOffDisabled = '#CCD1D5';
var ToggleBorderOn = '#2D3C48';
var ToggleBorderOnDisabled = '#CCD1D5';
var ToggleBorderOff = '#2D3C48';
var ToggleBorderOffDisabled = '#CCD1D5';
var ToggleForegroundOn = '#ffffff';
var ToggleForegroundOnDisabled = '#6E767E';
var ToggleForegroundOff = '#ffffff';
var ToggleForegroundOffDisabled = '#ffffff';
var TooltipHighlightBackground = '#009AD4';
var TooltipHighlightBackgroundHovered = '#0089BD';
var TooltipHighlightBackgroundPressed = '#0089BD';
var TooltipHighlightForeground = '#ffffff';
var TooltipHighlightForegroundHovered = '#ffffff';
var TooltipHighlightForegroundPressed = '#ffffff';
var TooltipInformationalBackground = '#2D3C48';
var TooltipInformationalBackgroundHovered = '#26333D';
var TooltipInformationalBackgroundPressed = '#1F2327';
var TooltipInformationalForeground = '#EFF1F3';
var TooltipInformationalForegroundHovered = '#EFF1F3';
var TooltipInformationalForegroundPressed = '#EFF1F3';
var WarningForeground = '#2D3C48';
var WarningBackground = '#FFF0C2';
var ColorSemanticsAll = {
  BackgroundElevated: BackgroundElevated,
  BackgroundOverlay: BackgroundOverlay,
  BackgroundPrimary: BackgroundPrimary,
  BackgroundPrimaryInverted: BackgroundPrimaryInverted,
  BackgroundSecondary: BackgroundSecondary,
  BackgroundSecondaryInverted: BackgroundSecondaryInverted,
  BackgroundSeparator: BackgroundSeparator,
  BackgroundTertiary: BackgroundTertiary,
  BannerDefaultBackground: BannerDefaultBackground,
  BannerDefaultForeground: BannerDefaultForeground,
  BannerDefaultIcon: BannerDefaultIcon,
  BannerHighlightBackground: BannerHighlightBackground,
  BannerHighlightDefaultBackground: BannerHighlightDefaultBackground,
  BannerHighlightDefaultForeground: BannerHighlightDefaultForeground,
  BannerHighlightDefaultIcon: BannerHighlightDefaultIcon,
  BannerHighlightEmphasisBackground: BannerHighlightEmphasisBackground,
  BannerHighlightEmphasisForeground: BannerHighlightEmphasisForeground,
  BannerHighlightEmphasisIcon: BannerHighlightEmphasisIcon,
  BannerHighlightForeground: BannerHighlightForeground,
  BannerHighlightIcon: BannerHighlightIcon,
  BannerHighlightSubduedBackground: BannerHighlightSubduedBackground,
  BannerHighlightSubduedBorder: BannerHighlightSubduedBorder,
  BannerHighlightSubduedDecorator: BannerHighlightSubduedDecorator,
  BannerHighlightSubduedForeground: BannerHighlightSubduedForeground,
  BannerHighlightSubduedIcon: BannerHighlightSubduedIcon,
  BannerHighlightSubduedIconBackground: BannerHighlightSubduedIconBackground,
  BannerInformationalBackground: BannerInformationalBackground,
  BannerInformationalDefaultBackground: BannerInformationalDefaultBackground,
  BannerInformationalDefaultForeground: BannerInformationalDefaultForeground,
  BannerInformationalDefaultIcon: BannerInformationalDefaultIcon,
  BannerInformationalEmphasisBackground: BannerInformationalEmphasisBackground,
  BannerInformationalEmphasisForeground: BannerInformationalEmphasisForeground,
  BannerInformationalEmphasisIcon: BannerInformationalEmphasisIcon,
  BannerInformationalForeground: BannerInformationalForeground,
  BannerInformationalIcon: BannerInformationalIcon,
  BannerInformationalSubduedBackground: BannerInformationalSubduedBackground,
  BannerInformationalSubduedBorder: BannerInformationalSubduedBorder,
  BannerInformationalSubduedDecorator: BannerInformationalSubduedDecorator,
  BannerInformationalSubduedForeground: BannerInformationalSubduedForeground,
  BannerInformationalSubduedIcon: BannerInformationalSubduedIcon,
  BannerInformationalSubduedIconBackground: BannerInformationalSubduedIconBackground,
  BannerNegativeBackground: BannerNegativeBackground,
  BannerNegativeDefaultBackground: BannerNegativeDefaultBackground,
  BannerNegativeDefaultForeground: BannerNegativeDefaultForeground,
  BannerNegativeDefaultIcon: BannerNegativeDefaultIcon,
  BannerNegativeEmphasisBackground: BannerNegativeEmphasisBackground,
  BannerNegativeEmphasisForeground: BannerNegativeEmphasisForeground,
  BannerNegativeEmphasisIcon: BannerNegativeEmphasisIcon,
  BannerNegativeForeground: BannerNegativeForeground,
  BannerNegativeIcon: BannerNegativeIcon,
  BannerNegativeSubduedBackground: BannerNegativeSubduedBackground,
  BannerNegativeSubduedBorder: BannerNegativeSubduedBorder,
  BannerNegativeSubduedDecorator: BannerNegativeSubduedDecorator,
  BannerNegativeSubduedForeground: BannerNegativeSubduedForeground,
  BannerNegativeSubduedIcon: BannerNegativeSubduedIcon,
  BannerNegativeSubduedIconBackground: BannerNegativeSubduedIconBackground,
  BannerPositiveBackground: BannerPositiveBackground,
  BannerPositiveDefaultBackground: BannerPositiveDefaultBackground,
  BannerPositiveDefaultForeground: BannerPositiveDefaultForeground,
  BannerPositiveDefaultIcon: BannerPositiveDefaultIcon,
  BannerPositiveEmphasisBackground: BannerPositiveEmphasisBackground,
  BannerPositiveEmphasisForeground: BannerPositiveEmphasisForeground,
  BannerPositiveEmphasisIcon: BannerPositiveEmphasisIcon,
  BannerPositiveForeground: BannerPositiveForeground,
  BannerPositiveIcon: BannerPositiveIcon,
  BannerPositiveSubduedBackground: BannerPositiveSubduedBackground,
  BannerPositiveSubduedBorder: BannerPositiveSubduedBorder,
  BannerPositiveSubduedDecorator: BannerPositiveSubduedDecorator,
  BannerPositiveSubduedForeground: BannerPositiveSubduedForeground,
  BannerPositiveSubduedIcon: BannerPositiveSubduedIcon,
  BannerPositiveSubduedIconBackground: BannerPositiveSubduedIconBackground,
  BannerWarningBackground: BannerWarningBackground,
  BannerWarningDefaultBackground: BannerWarningDefaultBackground,
  BannerWarningDefaultForeground: BannerWarningDefaultForeground,
  BannerWarningDefaultIcon: BannerWarningDefaultIcon,
  BannerWarningEmphasisBackground: BannerWarningEmphasisBackground,
  BannerWarningEmphasisForeground: BannerWarningEmphasisForeground,
  BannerWarningEmphasisIcon: BannerWarningEmphasisIcon,
  BannerWarningForeground: BannerWarningForeground,
  BannerWarningIcon: BannerWarningIcon,
  BannerWarningSubduedBackground: BannerWarningSubduedBackground,
  BannerWarningSubduedBorder: BannerWarningSubduedBorder,
  BannerWarningSubduedDecorator: BannerWarningSubduedDecorator,
  BannerWarningSubduedForeground: BannerWarningSubduedForeground,
  BannerWarningSubduedIcon: BannerWarningSubduedIcon,
  BannerWarningSubduedIconBackground: BannerWarningSubduedIconBackground,
  BorderError: BorderError,
  BorderErrorDisabled: BorderErrorDisabled,
  BorderFocus: BorderFocus,
  BorderPrimary: BorderPrimary,
  BorderSecondary: BorderSecondary,
  ButtonDefaultToggleForegroundDisabled: ButtonDefaultToggleForegroundDisabled,
  ButtonDefaultToggleForegroundOff: ButtonDefaultToggleForegroundOff,
  ButtonDefaultToggleForegroundOffDisabled: ButtonDefaultToggleForegroundOffDisabled,
  ButtonDefaultToggleForegroundOffHovered: ButtonDefaultToggleForegroundOffHovered,
  ButtonDefaultToggleForegroundOffPressed: ButtonDefaultToggleForegroundOffPressed,
  ButtonDestructiveBackground: ButtonDestructiveBackground,
  ButtonDestructiveBackgroundDisabled: ButtonDestructiveBackgroundDisabled,
  ButtonDestructiveBackgroundHovered: ButtonDestructiveBackgroundHovered,
  ButtonDestructiveBackgroundPressed: ButtonDestructiveBackgroundPressed,
  ButtonDestructiveForeground: ButtonDestructiveForeground,
  ButtonDestructiveForegroundDisabled: ButtonDestructiveForegroundDisabled,
  ButtonFabBackground: ButtonFabBackground,
  ButtonFabBackgroundHovered: ButtonFabBackgroundHovered,
  ButtonFabBackgroundPressed: ButtonFabBackgroundPressed,
  ButtonFabForeground: ButtonFabForeground,
  ButtonFabForegroundHovered: ButtonFabForegroundHovered,
  ButtonFabForegroundPressed: ButtonFabForegroundPressed,
  ButtonFlatPrimaryForeground: ButtonFlatPrimaryForeground,
  ButtonFlatPrimaryForegroundDisabled: ButtonFlatPrimaryForegroundDisabled,
  ButtonFlatPrimaryForegroundHovered: ButtonFlatPrimaryForegroundHovered,
  ButtonFlatPrimaryForegroundPressed: ButtonFlatPrimaryForegroundPressed,
  ButtonFlatSecondaryForeground: ButtonFlatSecondaryForeground,
  ButtonFlatSecondaryForegroundDisabled: ButtonFlatSecondaryForegroundDisabled,
  ButtonFlatSecondaryForegroundHovered: ButtonFlatSecondaryForegroundHovered,
  ButtonFlatSecondaryForegroundPressed: ButtonFlatSecondaryForegroundPressed,
  ButtonFloatingToggleGroupBackgroundColorOff: ButtonFloatingToggleGroupBackgroundColorOff,
  ButtonLinkForeground: ButtonLinkForeground,
  ButtonLinkForegroundDisabled: ButtonLinkForegroundDisabled,
  ButtonLinkForegroundHovered: ButtonLinkForegroundHovered,
  ButtonLinkForegroundPressed: ButtonLinkForegroundPressed,
  ButtonPlainForeground: ButtonPlainForeground,
  ButtonPlainForegroundDisabled: ButtonPlainForegroundDisabled,
  ButtonPlainForegroundHovered: ButtonPlainForegroundHovered,
  ButtonPlainForegroundPressed: ButtonPlainForegroundPressed,
  ButtonPlainToggleForeground: ButtonPlainToggleForeground,
  ButtonPlainToggleForegroundDisabled: ButtonPlainToggleForegroundDisabled,
  ButtonPlainToggleForegroundHovered: ButtonPlainToggleForegroundHovered,
  ButtonPlainToggleForegroundOff: ButtonPlainToggleForegroundOff,
  ButtonPlainToggleForegroundOffDisabled: ButtonPlainToggleForegroundOffDisabled,
  ButtonPlainToggleForegroundOffHovered: ButtonPlainToggleForegroundOffHovered,
  ButtonPlainToggleForegroundOffPressed: ButtonPlainToggleForegroundOffPressed,
  ButtonPlainToggleForegroundPressed: ButtonPlainToggleForegroundPressed,
  ButtonPrimaryBackground: ButtonPrimaryBackground,
  ButtonPrimaryBackgroundDisabled: ButtonPrimaryBackgroundDisabled,
  ButtonPrimaryBackgroundHovered: ButtonPrimaryBackgroundHovered,
  ButtonPrimaryBackgroundPressed: ButtonPrimaryBackgroundPressed,
  ButtonPrimaryForeground: ButtonPrimaryForeground,
  ButtonPrimaryForegroundDisabled: ButtonPrimaryForegroundDisabled,
  ButtonPrimaryForegroundHovered: ButtonPrimaryForegroundHovered,
  ButtonPrimaryForegroundPressed: ButtonPrimaryForegroundPressed,
  ButtonPrimaryToggleBackground: ButtonPrimaryToggleBackground,
  ButtonPrimaryToggleBackgroundDisabled: ButtonPrimaryToggleBackgroundDisabled,
  ButtonPrimaryToggleBackgroundHovered: ButtonPrimaryToggleBackgroundHovered,
  ButtonPrimaryToggleBackgroundOff: ButtonPrimaryToggleBackgroundOff,
  ButtonPrimaryToggleBackgroundOffDisabled: ButtonPrimaryToggleBackgroundOffDisabled,
  ButtonPrimaryToggleBackgroundOffHovered: ButtonPrimaryToggleBackgroundOffHovered,
  ButtonPrimaryToggleBackgroundOffPressed: ButtonPrimaryToggleBackgroundOffPressed,
  ButtonPrimaryToggleBackgroundPressed: ButtonPrimaryToggleBackgroundPressed,
  ButtonPrimaryToggleBorderOff: ButtonPrimaryToggleBorderOff,
  ButtonPrimaryToggleBorderOffDisabled: ButtonPrimaryToggleBorderOffDisabled,
  ButtonPrimaryToggleBorderOffHovered: ButtonPrimaryToggleBorderOffHovered,
  ButtonPrimaryToggleBorderOffPressed: ButtonPrimaryToggleBorderOffPressed,
  ButtonPrimaryToggleBorderOn: ButtonPrimaryToggleBorderOn,
  ButtonPrimaryToggleBorderOnDisabled: ButtonPrimaryToggleBorderOnDisabled,
  ButtonPrimaryToggleBorderOnHovered: ButtonPrimaryToggleBorderOnHovered,
  ButtonPrimaryToggleBorderOnPressed: ButtonPrimaryToggleBorderOnPressed,
  ButtonPrimaryToggleForeground: ButtonPrimaryToggleForeground,
  ButtonPrimaryToggleForegroundDisabled: ButtonPrimaryToggleForegroundDisabled,
  ButtonPrimaryToggleForegroundHovered: ButtonPrimaryToggleForegroundHovered,
  ButtonPrimaryToggleForegroundOff: ButtonPrimaryToggleForegroundOff,
  ButtonPrimaryToggleForegroundOffDisabled: ButtonPrimaryToggleForegroundOffDisabled,
  ButtonPrimaryToggleForegroundOffHovered: ButtonPrimaryToggleForegroundOffHovered,
  ButtonPrimaryToggleForegroundOffPressed: ButtonPrimaryToggleForegroundOffPressed,
  ButtonPrimaryToggleForegroundPressed: ButtonPrimaryToggleForegroundPressed,
  ButtonPrimaryToggleGroupBackgroundOff: ButtonPrimaryToggleGroupBackgroundOff,
  ButtonPrimaryToggleGroupBackgroundOffDisabled: ButtonPrimaryToggleGroupBackgroundOffDisabled,
  ButtonPrimaryToggleGroupBackgroundOffHovered: ButtonPrimaryToggleGroupBackgroundOffHovered,
  ButtonPrimaryToggleGroupBackgroundOffPressed: ButtonPrimaryToggleGroupBackgroundOffPressed,
  ButtonPrimaryToggleGroupBackgroundOn: ButtonPrimaryToggleGroupBackgroundOn,
  ButtonPrimaryToggleGroupBackgroundOnDisabled: ButtonPrimaryToggleGroupBackgroundOnDisabled,
  ButtonPrimaryToggleGroupBackgroundOnHovered: ButtonPrimaryToggleGroupBackgroundOnHovered,
  ButtonPrimaryToggleGroupBackgroundOnPressed: ButtonPrimaryToggleGroupBackgroundOnPressed,
  ButtonPrimaryToggleGroupBorderOff: ButtonPrimaryToggleGroupBorderOff,
  ButtonPrimaryToggleGroupBorderOffDisabled: ButtonPrimaryToggleGroupBorderOffDisabled,
  ButtonPrimaryToggleGroupBorderOffHovered: ButtonPrimaryToggleGroupBorderOffHovered,
  ButtonPrimaryToggleGroupBorderOffPressed: ButtonPrimaryToggleGroupBorderOffPressed,
  ButtonPrimaryToggleGroupBorderOn: ButtonPrimaryToggleGroupBorderOn,
  ButtonPrimaryToggleGroupBorderOnDisabled: ButtonPrimaryToggleGroupBorderOnDisabled,
  ButtonPrimaryToggleGroupBorderOnHovered: ButtonPrimaryToggleGroupBorderOnHovered,
  ButtonPrimaryToggleGroupBorderOnPressed: ButtonPrimaryToggleGroupBorderOnPressed,
  ButtonPrimaryToggleGroupForegroundOff: ButtonPrimaryToggleGroupForegroundOff,
  ButtonPrimaryToggleGroupForegroundOffDisabled: ButtonPrimaryToggleGroupForegroundOffDisabled,
  ButtonPrimaryToggleGroupForegroundOffHovered: ButtonPrimaryToggleGroupForegroundOffHovered,
  ButtonPrimaryToggleGroupForegroundOffPressed: ButtonPrimaryToggleGroupForegroundOffPressed,
  ButtonPrimaryToggleGroupForegroundOnDisabled: ButtonPrimaryToggleGroupForegroundOnDisabled,
  ButtonSecondaryBackground: ButtonSecondaryBackground,
  ButtonSecondaryBackgroundDisabled: ButtonSecondaryBackgroundDisabled,
  ButtonSecondaryBackgroundHovered: ButtonSecondaryBackgroundHovered,
  ButtonSecondaryBackgroundPressed: ButtonSecondaryBackgroundPressed,
  ButtonSecondaryForeground: ButtonSecondaryForeground,
  ButtonSecondaryForegroundDisabled: ButtonSecondaryForegroundDisabled,
  ButtonSecondaryForegroundHovered: ButtonSecondaryForegroundHovered,
  ButtonSecondaryForegroundPressed: ButtonSecondaryForegroundPressed,
  ButtonSecondaryToggleBackground: ButtonSecondaryToggleBackground,
  ButtonSecondaryToggleBackgroundDisabled: ButtonSecondaryToggleBackgroundDisabled,
  ButtonSecondaryToggleBackgroundHovered: ButtonSecondaryToggleBackgroundHovered,
  ButtonSecondaryToggleBackgroundOff: ButtonSecondaryToggleBackgroundOff,
  ButtonSecondaryToggleBackgroundOffDisabled: ButtonSecondaryToggleBackgroundOffDisabled,
  ButtonSecondaryToggleBackgroundOffHovered: ButtonSecondaryToggleBackgroundOffHovered,
  ButtonSecondaryToggleBackgroundOffPressed: ButtonSecondaryToggleBackgroundOffPressed,
  ButtonSecondaryToggleBackgroundPressed: ButtonSecondaryToggleBackgroundPressed,
  ButtonSecondaryToggleBorderOff: ButtonSecondaryToggleBorderOff,
  ButtonSecondaryToggleBorderOffDisabled: ButtonSecondaryToggleBorderOffDisabled,
  ButtonSecondaryToggleBorderOffHovered: ButtonSecondaryToggleBorderOffHovered,
  ButtonSecondaryToggleBorderOffPressed: ButtonSecondaryToggleBorderOffPressed,
  ButtonSecondaryToggleBorderOn: ButtonSecondaryToggleBorderOn,
  ButtonSecondaryToggleBorderOnDisabled: ButtonSecondaryToggleBorderOnDisabled,
  ButtonSecondaryToggleBorderOnHovered: ButtonSecondaryToggleBorderOnHovered,
  ButtonSecondaryToggleBorderOnPressed: ButtonSecondaryToggleBorderOnPressed,
  ButtonSecondaryToggleForeground: ButtonSecondaryToggleForeground,
  ButtonSecondaryToggleForegroundDisabled: ButtonSecondaryToggleForegroundDisabled,
  ButtonSecondaryToggleForegroundHovered: ButtonSecondaryToggleForegroundHovered,
  ButtonSecondaryToggleForegroundOff: ButtonSecondaryToggleForegroundOff,
  ButtonSecondaryToggleForegroundOffDisabled: ButtonSecondaryToggleForegroundOffDisabled,
  ButtonSecondaryToggleForegroundOffHovered: ButtonSecondaryToggleForegroundOffHovered,
  ButtonSecondaryToggleForegroundOffPressed: ButtonSecondaryToggleForegroundOffPressed,
  ButtonSecondaryToggleForegroundPressed: ButtonSecondaryToggleForegroundPressed,
  ButtonSecondaryToggleGroupBackgroundOff: ButtonSecondaryToggleGroupBackgroundOff,
  ButtonSecondaryToggleGroupBackgroundOffDisabled: ButtonSecondaryToggleGroupBackgroundOffDisabled,
  ButtonSecondaryToggleGroupBackgroundOffHovered: ButtonSecondaryToggleGroupBackgroundOffHovered,
  ButtonSecondaryToggleGroupBackgroundOffPressed: ButtonSecondaryToggleGroupBackgroundOffPressed,
  ButtonSecondaryToggleGroupBackgroundOn: ButtonSecondaryToggleGroupBackgroundOn,
  ButtonSecondaryToggleGroupBackgroundOnDisabled: ButtonSecondaryToggleGroupBackgroundOnDisabled,
  ButtonSecondaryToggleGroupBackgroundOnHovered: ButtonSecondaryToggleGroupBackgroundOnHovered,
  ButtonSecondaryToggleGroupBackgroundOnPressed: ButtonSecondaryToggleGroupBackgroundOnPressed,
  ButtonSecondaryToggleGroupBorderOff: ButtonSecondaryToggleGroupBorderOff,
  ButtonSecondaryToggleGroupBorderOffDisabled: ButtonSecondaryToggleGroupBorderOffDisabled,
  ButtonSecondaryToggleGroupBorderOffHovered: ButtonSecondaryToggleGroupBorderOffHovered,
  ButtonSecondaryToggleGroupBorderOffPressed: ButtonSecondaryToggleGroupBorderOffPressed,
  ButtonSecondaryToggleGroupBorderOn: ButtonSecondaryToggleGroupBorderOn,
  ButtonSecondaryToggleGroupBorderOnDisabled: ButtonSecondaryToggleGroupBorderOnDisabled,
  ButtonSecondaryToggleGroupBorderOnHovered: ButtonSecondaryToggleGroupBorderOnHovered,
  ButtonSecondaryToggleGroupBorderOnPressed: ButtonSecondaryToggleGroupBorderOnPressed,
  ButtonSecondaryToggleGroupForegroundOff: ButtonSecondaryToggleGroupForegroundOff,
  ButtonSecondaryToggleGroupForegroundOffDisabled: ButtonSecondaryToggleGroupForegroundOffDisabled,
  ButtonSecondaryToggleGroupForegroundOffHovered: ButtonSecondaryToggleGroupForegroundOffHovered,
  ButtonSecondaryToggleGroupForegroundOffPressed: ButtonSecondaryToggleGroupForegroundOffPressed,
  ButtonSecondaryToggleGroupForegroundOnDisabled: ButtonSecondaryToggleGroupForegroundOnDisabled,
  ButtonTabBackgroundOffDefault: ButtonTabBackgroundOffDefault,
  ButtonTabBackgroundOffDisabled: ButtonTabBackgroundOffDisabled,
  ButtonTabBackgroundOffHovered: ButtonTabBackgroundOffHovered,
  ButtonTabBackgroundOffPressed: ButtonTabBackgroundOffPressed,
  ButtonTabBackgroundOnDefault: ButtonTabBackgroundOnDefault,
  ButtonTabBackgroundOnDisabled: ButtonTabBackgroundOnDisabled,
  ButtonTabBackgroundOnHovered: ButtonTabBackgroundOnHovered,
  ButtonTabBackgroundOnPressed: ButtonTabBackgroundOnPressed,
  ButtonTabForegroundOffDefault: ButtonTabForegroundOffDefault,
  ButtonTabForegroundOffDisabled: ButtonTabForegroundOffDisabled,
  ButtonTabForegroundOffHovered: ButtonTabForegroundOffHovered,
  ButtonTabForegroundOffPressed: ButtonTabForegroundOffPressed,
  ButtonTabForegroundOnDefault: ButtonTabForegroundOnDefault,
  ButtonTabForegroundOnDisabled: ButtonTabForegroundOnDisabled,
  ButtonTabForegroundOnHovered: ButtonTabForegroundOnHovered,
  ButtonTabForegroundOnPressed: ButtonTabForegroundOnPressed,
  ButtonTertiaryBackground: ButtonTertiaryBackground,
  ButtonTertiaryBackgroundDisabled: ButtonTertiaryBackgroundDisabled,
  ButtonTertiaryBackgroundHovered: ButtonTertiaryBackgroundHovered,
  ButtonTertiaryBackgroundPressed: ButtonTertiaryBackgroundPressed,
  ButtonTertiaryBorder: ButtonTertiaryBorder,
  ButtonTertiaryBorderDisabled: ButtonTertiaryBorderDisabled,
  ButtonTertiaryBorderHovered: ButtonTertiaryBorderHovered,
  ButtonTertiaryBorderPressed: ButtonTertiaryBorderPressed,
  ButtonTertiaryForeground: ButtonTertiaryForeground,
  ButtonTertiaryForegroundDisabled: ButtonTertiaryForegroundDisabled,
  ButtonTertiaryForegroundHovered: ButtonTertiaryForegroundHovered,
  ButtonTertiaryForegroundPressed: ButtonTertiaryForegroundPressed,
  ButtonTertiaryToggleBackground: ButtonTertiaryToggleBackground,
  ButtonTertiaryToggleBackgroundDisabled: ButtonTertiaryToggleBackgroundDisabled,
  ButtonTertiaryToggleBackgroundHovered: ButtonTertiaryToggleBackgroundHovered,
  ButtonTertiaryToggleBackgroundOff: ButtonTertiaryToggleBackgroundOff,
  ButtonTertiaryToggleBackgroundOffDisabled: ButtonTertiaryToggleBackgroundOffDisabled,
  ButtonTertiaryToggleBackgroundOffHovered: ButtonTertiaryToggleBackgroundOffHovered,
  ButtonTertiaryToggleBackgroundOffPressed: ButtonTertiaryToggleBackgroundOffPressed,
  ButtonTertiaryToggleBackgroundPressed: ButtonTertiaryToggleBackgroundPressed,
  ButtonTertiaryToggleBorderOff: ButtonTertiaryToggleBorderOff,
  ButtonTertiaryToggleBorderOffDisabled: ButtonTertiaryToggleBorderOffDisabled,
  ButtonTertiaryToggleBorderOffHovered: ButtonTertiaryToggleBorderOffHovered,
  ButtonTertiaryToggleBorderOffPressed: ButtonTertiaryToggleBorderOffPressed,
  ButtonTertiaryToggleBorderOn: ButtonTertiaryToggleBorderOn,
  ButtonTertiaryToggleBorderOnDisabled: ButtonTertiaryToggleBorderOnDisabled,
  ButtonTertiaryToggleBorderOnHovered: ButtonTertiaryToggleBorderOnHovered,
  ButtonTertiaryToggleBorderOnPressed: ButtonTertiaryToggleBorderOnPressed,
  ButtonTertiaryToggleForeground: ButtonTertiaryToggleForeground,
  ButtonTertiaryToggleForegroundDisabled: ButtonTertiaryToggleForegroundDisabled,
  ButtonTertiaryToggleForegroundHovered: ButtonTertiaryToggleForegroundHovered,
  ButtonTertiaryToggleForegroundOff: ButtonTertiaryToggleForegroundOff,
  ButtonTertiaryToggleForegroundOffDisabled: ButtonTertiaryToggleForegroundOffDisabled,
  ButtonTertiaryToggleForegroundOffHovered: ButtonTertiaryToggleForegroundOffHovered,
  ButtonTertiaryToggleForegroundOffPressed: ButtonTertiaryToggleForegroundOffPressed,
  ButtonTertiaryToggleForegroundPressed: ButtonTertiaryToggleForegroundPressed,
  ButtonTertiaryToggleGroupBackgroundOff: ButtonTertiaryToggleGroupBackgroundOff,
  ButtonTertiaryToggleGroupBackgroundOffDisabled: ButtonTertiaryToggleGroupBackgroundOffDisabled,
  ButtonTertiaryToggleGroupBackgroundOffHovered: ButtonTertiaryToggleGroupBackgroundOffHovered,
  ButtonTertiaryToggleGroupBackgroundOffPressed: ButtonTertiaryToggleGroupBackgroundOffPressed,
  ButtonTertiaryToggleGroupBackgroundOn: ButtonTertiaryToggleGroupBackgroundOn,
  ButtonTertiaryToggleGroupBackgroundOnDisabled: ButtonTertiaryToggleGroupBackgroundOnDisabled,
  ButtonTertiaryToggleGroupBackgroundOnHovered: ButtonTertiaryToggleGroupBackgroundOnHovered,
  ButtonTertiaryToggleGroupBackgroundOnPressed: ButtonTertiaryToggleGroupBackgroundOnPressed,
  ButtonTertiaryToggleGroupBorderOff: ButtonTertiaryToggleGroupBorderOff,
  ButtonTertiaryToggleGroupBorderOffDisabled: ButtonTertiaryToggleGroupBorderOffDisabled,
  ButtonTertiaryToggleGroupBorderOffHovered: ButtonTertiaryToggleGroupBorderOffHovered,
  ButtonTertiaryToggleGroupBorderOffPressed: ButtonTertiaryToggleGroupBorderOffPressed,
  ButtonTertiaryToggleGroupBorderOn: ButtonTertiaryToggleGroupBorderOn,
  ButtonTertiaryToggleGroupBorderOnDisabled: ButtonTertiaryToggleGroupBorderOnDisabled,
  ButtonTertiaryToggleGroupBorderOnHovered: ButtonTertiaryToggleGroupBorderOnHovered,
  ButtonTertiaryToggleGroupBorderOnPressed: ButtonTertiaryToggleGroupBorderOnPressed,
  ButtonTertiaryToggleGroupForegroundOff: ButtonTertiaryToggleGroupForegroundOff,
  ButtonTertiaryToggleGroupForegroundOffDisabled: ButtonTertiaryToggleGroupForegroundOffDisabled,
  ButtonTertiaryToggleGroupForegroundOffHovered: ButtonTertiaryToggleGroupForegroundOffHovered,
  ButtonTertiaryToggleGroupForegroundOffPressed: ButtonTertiaryToggleGroupForegroundOffPressed,
  ButtonTertiaryToggleGroupForegroundOn: ButtonTertiaryToggleGroupForegroundOn,
  ButtonTertiaryToggleGroupForegroundOnDisabled: ButtonTertiaryToggleGroupForegroundOnDisabled,
  ButtonTertiaryToggleGroupForegroundOnHovered: ButtonTertiaryToggleGroupForegroundOnHovered,
  ButtonTertiaryToggleGroupForegroundOnPressed: ButtonTertiaryToggleGroupForegroundOnPressed,
  CardBackgroundDefault: CardBackgroundDefault,
  CardBackgroundDisabled: CardBackgroundDisabled,
  CardBackgroundHovered: CardBackgroundHovered,
  CardBackgroundPressed: CardBackgroundPressed,
  CardBodyDefault: CardBodyDefault,
  CardBodyDisabled: CardBodyDisabled,
  CardBodyHovered: CardBodyHovered,
  CardBodyPressed: CardBodyPressed,
  CardBorderSelectedDefault: CardBorderSelectedDefault,
  CardBorderSelectedDisabled: CardBorderSelectedDisabled,
  CardBorderSelectedError: CardBorderSelectedError,
  CardBorderSelectedErrorDisabled: CardBorderSelectedErrorDisabled,
  CardBorderSelectedHovered: CardBorderSelectedHovered,
  CardBorderSelectedPressed: CardBorderSelectedPressed,
  CardBorderUnselectedDefault: CardBorderUnselectedDefault,
  CardBorderUnselectedDisabled: CardBorderUnselectedDisabled,
  CardBorderUnselectedError: CardBorderUnselectedError,
  CardBorderUnselectedErrorDisabled: CardBorderUnselectedErrorDisabled,
  CardBorderUnselectedHovered: CardBorderUnselectedHovered,
  CardBorderUnselectedPressed: CardBorderUnselectedPressed,
  CardTitleDefault: CardTitleDefault,
  CardTitleDisabled: CardTitleDisabled,
  CardTitleHovered: CardTitleHovered,
  CardTitlePressed: CardTitlePressed,
  ChatIncomingBackground: ChatIncomingBackground,
  ChatIncomingForeground: ChatIncomingForeground,
  ChatOutgoingBackground: ChatOutgoingBackground,
  ChatOutgoingForeground: ChatOutgoingForeground,
  DatePickerDateBorderSelected: DatePickerDateBorderSelected,
  DatePickerDateBorderSelectedDisabled: DatePickerDateBorderSelectedDisabled,
  DatePickerDateBorderSelectedHovered: DatePickerDateBorderSelectedHovered,
  DatePickerDateBorderSelectedPressed: DatePickerDateBorderSelectedPressed,
  DatePickerDateBorderUnselected: DatePickerDateBorderUnselected,
  DatePickerDateBorderUnselectedDisabled: DatePickerDateBorderUnselectedDisabled,
  DatePickerDateBorderUnselectedHovered: DatePickerDateBorderUnselectedHovered,
  DatePickerDateBorderUnselectedPressed: DatePickerDateBorderUnselectedPressed,
  DatePickerDateForegroundSelected: DatePickerDateForegroundSelected,
  DatePickerDateForegroundSelectedDisabled: DatePickerDateForegroundSelectedDisabled,
  DatePickerDateForegroundSelectedHovered: DatePickerDateForegroundSelectedHovered,
  DatePickerDateForegroundSelectedPressed: DatePickerDateForegroundSelectedPressed,
  DatePickerDateForegroundUnselected: DatePickerDateForegroundUnselected,
  DatePickerDateForegroundUnselectedDisabled: DatePickerDateForegroundUnselectedDisabled,
  DatePickerDateForegroundUnselectedHovered: DatePickerDateForegroundUnselectedHovered,
  DatePickerDateForegroundUnselectedPressed: DatePickerDateForegroundUnselectedPressed,
  DatePickerDateSelectedBackground: DatePickerDateSelectedBackground,
  DatePickerDateSelectedBackgroundDisabled: DatePickerDateSelectedBackgroundDisabled,
  DatePickerDateSelectedBackgroundHovered: DatePickerDateSelectedBackgroundHovered,
  DatePickerDateSelectedBackgroundPressed: DatePickerDateSelectedBackgroundPressed,
  DatePickerDateSelectedIndicatorDisabled: DatePickerDateSelectedIndicatorDisabled,
  DatePickerDateSelectedIndicatorPrimary: DatePickerDateSelectedIndicatorPrimary,
  DatePickerDateSelectedIndicatorSecondary: DatePickerDateSelectedIndicatorSecondary,
  DatePickerDateUnselectedBackground: DatePickerDateUnselectedBackground,
  DatePickerDateUnselectedBackgroundDisabled: DatePickerDateUnselectedBackgroundDisabled,
  DatePickerDateUnselectedBackgroundHovered: DatePickerDateUnselectedBackgroundHovered,
  DatePickerDateUnselectedBackgroundPressed: DatePickerDateUnselectedBackgroundPressed,
  DatePickerDateUnselectedIndicatorDisabled: DatePickerDateUnselectedIndicatorDisabled,
  DatePickerDateUnselectedIndicatorPrimary: DatePickerDateUnselectedIndicatorPrimary,
  DatePickerDateUnselectedIndicatorSecondary: DatePickerDateUnselectedIndicatorSecondary,
  DatePickerRangeBorderSelected: DatePickerRangeBorderSelected,
  DatePickerRangeBorderSelectedDisabled: DatePickerRangeBorderSelectedDisabled,
  DatePickerRangeBorderSelectedHovered: DatePickerRangeBorderSelectedHovered,
  DatePickerRangeBorderSelectedPressed: DatePickerRangeBorderSelectedPressed,
  DatePickerRangeBorderUnselected: DatePickerRangeBorderUnselected,
  DatePickerRangeBorderUnselectedDisabled: DatePickerRangeBorderUnselectedDisabled,
  DatePickerRangeBorderUnselectedHovered: DatePickerRangeBorderUnselectedHovered,
  DatePickerRangeBorderUnselectedPressed: DatePickerRangeBorderUnselectedPressed,
  DatePickerRangeForegroundSelected: DatePickerRangeForegroundSelected,
  DatePickerRangeForegroundSelectedDisabled: DatePickerRangeForegroundSelectedDisabled,
  DatePickerRangeForegroundSelectedHovered: DatePickerRangeForegroundSelectedHovered,
  DatePickerRangeForegroundSelectedPressed: DatePickerRangeForegroundSelectedPressed,
  DatePickerRangeForegroundUnselected: DatePickerRangeForegroundUnselected,
  DatePickerRangeForegroundUnselectedDisabled: DatePickerRangeForegroundUnselectedDisabled,
  DatePickerRangeForegroundUnselectedHovered: DatePickerRangeForegroundUnselectedHovered,
  DatePickerRangeForegroundUnselectedPressed: DatePickerRangeForegroundUnselectedPressed,
  DatePickerRangeSelectedBackground: DatePickerRangeSelectedBackground,
  DatePickerRangeSelectedBackgroundDisabled: DatePickerRangeSelectedBackgroundDisabled,
  DatePickerRangeSelectedBackgroundHovered: DatePickerRangeSelectedBackgroundHovered,
  DatePickerRangeSelectedBackgroundPressed: DatePickerRangeSelectedBackgroundPressed,
  DatePickerRangeSelectedIndicatorDisabled: DatePickerRangeSelectedIndicatorDisabled,
  DatePickerRangeSelectedIndicatorPrimary: DatePickerRangeSelectedIndicatorPrimary,
  DatePickerRangeSelectedIndicatorSecondary: DatePickerRangeSelectedIndicatorSecondary,
  DatePickerRangeUnselectedBackground: DatePickerRangeUnselectedBackground,
  DatePickerRangeUnselectedBackgroundDisabled: DatePickerRangeUnselectedBackgroundDisabled,
  DatePickerRangeUnselectedBackgroundHovered: DatePickerRangeUnselectedBackgroundHovered,
  DatePickerRangeUnselectedBackgroundPressed: DatePickerRangeUnselectedBackgroundPressed,
  DatePickerTodayBorderSelected: DatePickerTodayBorderSelected,
  FieldsBackgroundActive: FieldsBackgroundActive,
  FieldsBackgroundDisabled: FieldsBackgroundDisabled,
  FieldsBackgroundError: FieldsBackgroundError,
  FieldsBackgroundInactive: FieldsBackgroundInactive,
  FieldsBorderActive: FieldsBorderActive,
  FieldsBorderDisabled: FieldsBorderDisabled,
  FieldsBorderError: FieldsBorderError,
  FieldsBorderInactive: FieldsBorderInactive,
  FieldsForegroundActive: FieldsForegroundActive,
  FieldsForegroundDisabled: FieldsForegroundDisabled,
  FieldsForegroundError: FieldsForegroundError,
  FieldsForegroundInactive: FieldsForegroundInactive,
  FieldsForegroundPlaceholder: FieldsForegroundPlaceholder,
  FieldsIconDropdown: FieldsIconDropdown,
  FieldsIconSearch: FieldsIconSearch,
  FieldsInputBackgroundDisabled: FieldsInputBackgroundDisabled,
  FieldsInputBorder: FieldsInputBorder,
  FieldsInputBorderError: FieldsInputBorderError,
  GlobalPrimary: GlobalPrimary,
  GlobalSecondary: GlobalSecondary,
  ListCellContainerBackgroundDefault: ListCellContainerBackgroundDefault,
  ListCellContainerBackgroundHovered: ListCellContainerBackgroundHovered,
  ListCellContainerBackgroundPressed: ListCellContainerBackgroundPressed,
  ListCellContainerBackgroundUnread: ListCellContainerBackgroundUnread,
  ListCellContainerBackgroundUnreadHovered: ListCellContainerBackgroundUnreadHovered,
  ListCellContainerBackgroundUnreadPressed: ListCellContainerBackgroundUnreadPressed,
  ListCellIconToggledOff: ListCellIconToggledOff,
  ListCellIconToggledOn: ListCellIconToggledOn,
  LoadingDefault: LoadingDefault,
  MenuItemBackground: MenuItemBackground,
  MenuItemBackgroundDisabled: MenuItemBackgroundDisabled,
  MenuItemBackgroundHovered: MenuItemBackgroundHovered,
  MenuItemBackgroundPressed: MenuItemBackgroundPressed,
  MenuItemForeground: MenuItemForeground,
  MenuItemForegroundDisabled: MenuItemForegroundDisabled,
  MenuItemForegroundHovered: MenuItemForegroundHovered,
  MenuItemForegroundPressed: MenuItemForegroundPressed,
  OverlayBackgroundDefault: OverlayBackgroundDefault,
  OverlayLoadingDefault: OverlayLoadingDefault,
  PageBackgroundSecondary: PageBackgroundSecondary,
  PageBackgroundTertiary: PageBackgroundTertiary,
  PaginationNumberedSelectedBackground: PaginationNumberedSelectedBackground,
  PaginationNumberedSelectedBackgroundDisabled: PaginationNumberedSelectedBackgroundDisabled,
  PaginationNumberedSelectedBackgroundHovered: PaginationNumberedSelectedBackgroundHovered,
  PaginationNumberedSelectedBackgroundPressed: PaginationNumberedSelectedBackgroundPressed,
  PaginationNumberedSelectedBorder: PaginationNumberedSelectedBorder,
  PaginationNumberedSelectedBorderDisabled: PaginationNumberedSelectedBorderDisabled,
  PaginationNumberedSelectedBorderHovered: PaginationNumberedSelectedBorderHovered,
  PaginationNumberedSelectedBorderPressed: PaginationNumberedSelectedBorderPressed,
  PaginationNumberedSelectedForeground: PaginationNumberedSelectedForeground,
  PaginationNumberedSelectedForegroundDisabled: PaginationNumberedSelectedForegroundDisabled,
  PaginationNumberedSelectedForegroundHovered: PaginationNumberedSelectedForegroundHovered,
  PaginationNumberedSelectedForegroundPressed: PaginationNumberedSelectedForegroundPressed,
  PaginationNumberedUnselectedBackground: PaginationNumberedUnselectedBackground,
  PaginationNumberedUnselectedBackgroundDisabled: PaginationNumberedUnselectedBackgroundDisabled,
  PaginationNumberedUnselectedBackgroundHovered: PaginationNumberedUnselectedBackgroundHovered,
  PaginationNumberedUnselectedBackgroundPressed: PaginationNumberedUnselectedBackgroundPressed,
  PaginationNumberedUnselectedBorder: PaginationNumberedUnselectedBorder,
  PaginationNumberedUnselectedBorderDisabled: PaginationNumberedUnselectedBorderDisabled,
  PaginationNumberedUnselectedBorderHovered: PaginationNumberedUnselectedBorderHovered,
  PaginationNumberedUnselectedBorderPressed: PaginationNumberedUnselectedBorderPressed,
  PaginationNumberedUnselectedForeground: PaginationNumberedUnselectedForeground,
  PaginationNumberedUnselectedForegroundDisabled: PaginationNumberedUnselectedForegroundDisabled,
  PaginationNumberedUnselectedForegroundHovered: PaginationNumberedUnselectedForegroundHovered,
  PaginationNumberedUnselectedForegroundPressed: PaginationNumberedUnselectedForegroundPressed,
  PaginationSelectedDark: PaginationSelectedDark,
  PaginationSelectedLight: PaginationSelectedLight,
  PaginationSelectedPrimary: PaginationSelectedPrimary,
  PaginationUnselectedDark: PaginationUnselectedDark,
  PaginationUnselectedLight: PaginationUnselectedLight,
  PaginationUnselectedPrimary: PaginationUnselectedPrimary,
  QuantityStepperFloatingCollapsedSelectedBackgroundDefault: QuantityStepperFloatingCollapsedSelectedBackgroundDefault,
  QuantityStepperFloatingCollapsedSelectedBackgroundDisabled: QuantityStepperFloatingCollapsedSelectedBackgroundDisabled,
  QuantityStepperFloatingCollapsedSelectedBackgroundHover: QuantityStepperFloatingCollapsedSelectedBackgroundHover,
  QuantityStepperFloatingCollapsedSelectedBackgroundPressed: QuantityStepperFloatingCollapsedSelectedBackgroundPressed,
  QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDefault: QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDefault,
  QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDisabled: QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDisabled,
  QuantityStepperFloatingCollapsedSelectedForegroundPrimaryHover: QuantityStepperFloatingCollapsedSelectedForegroundPrimaryHover,
  QuantityStepperFloatingCollapsedSelectedForegroundPrimaryPressed: QuantityStepperFloatingCollapsedSelectedForegroundPrimaryPressed,
  QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDefault: QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDefault,
  QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDisabled: QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDisabled,
  QuantityStepperFloatingCollapsedSelectedForegroundSecondaryHover: QuantityStepperFloatingCollapsedSelectedForegroundSecondaryHover,
  QuantityStepperFloatingCollapsedSelectedForegroundSecondaryPressed: QuantityStepperFloatingCollapsedSelectedForegroundSecondaryPressed,
  QuantityStepperFloatingCollapsedUnselectedBackgroundDefault: QuantityStepperFloatingCollapsedUnselectedBackgroundDefault,
  QuantityStepperFloatingCollapsedUnselectedBackgroundDisabled: QuantityStepperFloatingCollapsedUnselectedBackgroundDisabled,
  QuantityStepperFloatingCollapsedUnselectedBackgroundHover: QuantityStepperFloatingCollapsedUnselectedBackgroundHover,
  QuantityStepperFloatingCollapsedUnselectedBackgroundPressed: QuantityStepperFloatingCollapsedUnselectedBackgroundPressed,
  QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDefault: QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDefault,
  QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDisabled: QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDisabled,
  QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryHover: QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryHover,
  QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryPressed: QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryPressed,
  QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDefault: QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDefault,
  QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDisabled: QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDisabled,
  QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryHover: QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryHover,
  QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryPressed: QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryPressed,
  QuantityStepperFloatingExpandedBackgroundDefault: QuantityStepperFloatingExpandedBackgroundDefault,
  QuantityStepperFloatingExpandedBackgroundDisabled: QuantityStepperFloatingExpandedBackgroundDisabled,
  QuantityStepperFloatingExpandedBackgroundHover: QuantityStepperFloatingExpandedBackgroundHover,
  QuantityStepperFloatingExpandedBackgroundPressed: QuantityStepperFloatingExpandedBackgroundPressed,
  QuantityStepperFloatingExpandedForegroundPrimaryDefault: QuantityStepperFloatingExpandedForegroundPrimaryDefault,
  QuantityStepperFloatingExpandedForegroundPrimaryDisabled: QuantityStepperFloatingExpandedForegroundPrimaryDisabled,
  QuantityStepperFloatingExpandedForegroundPrimaryHover: QuantityStepperFloatingExpandedForegroundPrimaryHover,
  QuantityStepperFloatingExpandedForegroundPrimaryPressed: QuantityStepperFloatingExpandedForegroundPrimaryPressed,
  QuantityStepperFloatingExpandedForegroundSecondaryDefault: QuantityStepperFloatingExpandedForegroundSecondaryDefault,
  QuantityStepperFloatingExpandedForegroundSecondaryDisabled: QuantityStepperFloatingExpandedForegroundSecondaryDisabled,
  QuantityStepperFloatingExpandedForegroundSecondaryHover: QuantityStepperFloatingExpandedForegroundSecondaryHover,
  QuantityStepperFloatingExpandedForegroundSecondaryPressed: QuantityStepperFloatingExpandedForegroundSecondaryPressed,
  SliderIcon: SliderIcon,
  SliderIconDisabled: SliderIconDisabled,
  SliderKnobBackground: SliderKnobBackground,
  SliderKnobBackgroundDisabled: SliderKnobBackgroundDisabled,
  SliderKnobBackgroundHovered: SliderKnobBackgroundHovered,
  SliderKnobBackgroundPressed: SliderKnobBackgroundPressed,
  SliderTextOff: SliderTextOff,
  SliderTextOffDisabled: SliderTextOffDisabled,
  SliderTextOn: SliderTextOn,
  SliderTextOnDisabled: SliderTextOnDisabled,
  SliderTrackBackgroundOff: SliderTrackBackgroundOff,
  SliderTrackBackgroundOffDisabled: SliderTrackBackgroundOffDisabled,
  SliderTrackBackgroundOn: SliderTrackBackgroundOn,
  SliderTrackBackgroundOnDisabled: SliderTrackBackgroundOnDisabled,
  SwitchBackgroundOff: SwitchBackgroundOff,
  SwitchBackgroundOffDisabled: SwitchBackgroundOffDisabled,
  SwitchBackgroundOn: SwitchBackgroundOn,
  SwitchBackgroundOnDisabled: SwitchBackgroundOnDisabled,
  SwitchBorderOff: SwitchBorderOff,
  SwitchBorderOffDisabled: SwitchBorderOffDisabled,
  SwitchBorderOn: SwitchBorderOn,
  SwitchBorderOnDisabled: SwitchBorderOnDisabled,
  SwitchForegroundOff: SwitchForegroundOff,
  SwitchForegroundOffDisabled: SwitchForegroundOffDisabled,
  SwitchForegroundOn: SwitchForegroundOn,
  SwitchForegroundOnDisabled: SwitchForegroundOnDisabled,
  SwitchThumbOff: SwitchThumbOff,
  SwitchThumbOffDisabled: SwitchThumbOffDisabled,
  SwitchThumbOn: SwitchThumbOn,
  SwitchThumbOnDisabled: SwitchThumbOnDisabled,
  SwitchTrackOff: SwitchTrackOff,
  SwitchTrackOffDisabled: SwitchTrackOffDisabled,
  SwitchTrackOn: SwitchTrackOn,
  SwitchTrackOnDisabled: SwitchTrackOnDisabled,
  TagDefaultBackground: TagDefaultBackground,
  TagDefaultBorder: TagDefaultBorder,
  TagDefaultForeground: TagDefaultForeground,
  TagDefaultIcon: TagDefaultIcon,
  TagHighlightBackground: TagHighlightBackground,
  TagHighlightBorder: TagHighlightBorder,
  TagHighlightDefaultBackground: TagHighlightDefaultBackground,
  TagHighlightDefaultBorder: TagHighlightDefaultBorder,
  TagHighlightDefaultForeground: TagHighlightDefaultForeground,
  TagHighlightDefaultIcon: TagHighlightDefaultIcon,
  TagHighlightEmphasisBackground: TagHighlightEmphasisBackground,
  TagHighlightEmphasisBorder: TagHighlightEmphasisBorder,
  TagHighlightEmphasisForeground: TagHighlightEmphasisForeground,
  TagHighlightEmphasisIcon: TagHighlightEmphasisIcon,
  TagHighlightForeground: TagHighlightForeground,
  TagHighlightIcon: TagHighlightIcon,
  TagHighlightSubduedBackground: TagHighlightSubduedBackground,
  TagHighlightSubduedBorder: TagHighlightSubduedBorder,
  TagHighlightSubduedForeground: TagHighlightSubduedForeground,
  TagHighlightSubduedIcon: TagHighlightSubduedIcon,
  TagInformationalBackground: TagInformationalBackground,
  TagInformationalBorder: TagInformationalBorder,
  TagInformationalDefaultBackground: TagInformationalDefaultBackground,
  TagInformationalDefaultBorder: TagInformationalDefaultBorder,
  TagInformationalDefaultForeground: TagInformationalDefaultForeground,
  TagInformationalDefaultIcon: TagInformationalDefaultIcon,
  TagInformationalEmphasisBackground: TagInformationalEmphasisBackground,
  TagInformationalEmphasisBorder: TagInformationalEmphasisBorder,
  TagInformationalEmphasisForeground: TagInformationalEmphasisForeground,
  TagInformationalEmphasisIcon: TagInformationalEmphasisIcon,
  TagInformationalForeground: TagInformationalForeground,
  TagInformationalIcon: TagInformationalIcon,
  TagInformationalSubduedBackground: TagInformationalSubduedBackground,
  TagInformationalSubduedBorder: TagInformationalSubduedBorder,
  TagInformationalSubduedForeground: TagInformationalSubduedForeground,
  TagInformationalSubduedIcon: TagInformationalSubduedIcon,
  TagNegativeBackground: TagNegativeBackground,
  TagNegativeBorder: TagNegativeBorder,
  TagNegativeDefaultBackground: TagNegativeDefaultBackground,
  TagNegativeDefaultBorder: TagNegativeDefaultBorder,
  TagNegativeDefaultForeground: TagNegativeDefaultForeground,
  TagNegativeDefaultIcon: TagNegativeDefaultIcon,
  TagNegativeEmphasisBackground: TagNegativeEmphasisBackground,
  TagNegativeEmphasisBorder: TagNegativeEmphasisBorder,
  TagNegativeEmphasisForeground: TagNegativeEmphasisForeground,
  TagNegativeEmphasisIcon: TagNegativeEmphasisIcon,
  TagNegativeForeground: TagNegativeForeground,
  TagNegativeIcon: TagNegativeIcon,
  TagNegativeSubduedBackground: TagNegativeSubduedBackground,
  TagNegativeSubduedBorder: TagNegativeSubduedBorder,
  TagNegativeSubduedForeground: TagNegativeSubduedForeground,
  TagNegativeSubduedIcon: TagNegativeSubduedIcon,
  TagPositiveBackground: TagPositiveBackground,
  TagPositiveBorder: TagPositiveBorder,
  TagPositiveDefaultBackground: TagPositiveDefaultBackground,
  TagPositiveDefaultBorder: TagPositiveDefaultBorder,
  TagPositiveDefaultForeground: TagPositiveDefaultForeground,
  TagPositiveDefaultIcon: TagPositiveDefaultIcon,
  TagPositiveEmphasisBackground: TagPositiveEmphasisBackground,
  TagPositiveEmphasisBorder: TagPositiveEmphasisBorder,
  TagPositiveEmphasisForeground: TagPositiveEmphasisForeground,
  TagPositiveEmphasisIcon: TagPositiveEmphasisIcon,
  TagPositiveForeground: TagPositiveForeground,
  TagPositiveIcon: TagPositiveIcon,
  TagPositiveSubduedBackground: TagPositiveSubduedBackground,
  TagPositiveSubduedBorder: TagPositiveSubduedBorder,
  TagPositiveSubduedForeground: TagPositiveSubduedForeground,
  TagPositiveSubduedIcon: TagPositiveSubduedIcon,
  TagWarningBackground: TagWarningBackground,
  TagWarningBorder: TagWarningBorder,
  TagWarningDefaultBackground: TagWarningDefaultBackground,
  TagWarningDefaultBorder: TagWarningDefaultBorder,
  TagWarningDefaultForeground: TagWarningDefaultForeground,
  TagWarningDefaultIcon: TagWarningDefaultIcon,
  TagWarningEmphasisBackground: TagWarningEmphasisBackground,
  TagWarningEmphasisBorder: TagWarningEmphasisBorder,
  TagWarningEmphasisForeground: TagWarningEmphasisForeground,
  TagWarningEmphasisIcon: TagWarningEmphasisIcon,
  TagWarningForeground: TagWarningForeground,
  TagWarningIcon: TagWarningIcon,
  TagWarningSubduedBackground: TagWarningSubduedBackground,
  TagWarningSubduedBorder: TagWarningSubduedBorder,
  TagWarningSubduedForeground: TagWarningSubduedForeground,
  TagWarningSubduedIcon: TagWarningSubduedIcon,
  TextAccentedPrimary: TextAccentedPrimary,
  TextAccentedSecondary: TextAccentedSecondary,
  TextAction: TextAction,
  TextCallout: TextCallout,
  TextDisabled: TextDisabled,
  TextError: TextError,
  TextHighlight: TextHighlight,
  TextPositive: TextPositive,
  TextPrimary: TextPrimary,
  TextPrimaryOnDark: TextPrimaryOnDark,
  TextSecondary: TextSecondary,
  TextSecondaryOnDark: TextSecondaryOnDark,
  TextSelected: TextSelected,
  TextTertiary: TextTertiary,
  TextTooltip: TextTooltip,
  TextWarning: TextWarning,
  TimelineTrackBackgroundOff: TimelineTrackBackgroundOff,
  TimelineTrackBackgroundOn: TimelineTrackBackgroundOn,
  TimelineTrackForegroundOff: TimelineTrackForegroundOff,
  TimelineTrackForegroundOn: TimelineTrackForegroundOn,
  TimelineTrackShimmer: TimelineTrackShimmer,
  ToastInformationalAction: ToastInformationalAction,
  ToastInformationalActionDisabled: ToastInformationalActionDisabled,
  ToastInformationalActionHovered: ToastInformationalActionHovered,
  ToastInformationalActionPressed: ToastInformationalActionPressed,
  ToastInformationalBackground: ToastInformationalBackground,
  ToastInformationalForeground: ToastInformationalForeground,
  ToggleBackgroundOff: ToggleBackgroundOff,
  ToggleBackgroundOffDisabled: ToggleBackgroundOffDisabled,
  ToggleBackgroundOn: ToggleBackgroundOn,
  ToggleBackgroundOnDisabled: ToggleBackgroundOnDisabled,
  ToggleBorderOff: ToggleBorderOff,
  ToggleBorderOffDisabled: ToggleBorderOffDisabled,
  ToggleBorderOn: ToggleBorderOn,
  ToggleBorderOnDisabled: ToggleBorderOnDisabled,
  ToggleForegroundOff: ToggleForegroundOff,
  ToggleForegroundOffDisabled: ToggleForegroundOffDisabled,
  ToggleForegroundOn: ToggleForegroundOn,
  ToggleForegroundOnDisabled: ToggleForegroundOnDisabled,
  TooltipHighlightBackground: TooltipHighlightBackground,
  TooltipHighlightBackgroundHovered: TooltipHighlightBackgroundHovered,
  TooltipHighlightBackgroundPressed: TooltipHighlightBackgroundPressed,
  TooltipHighlightForeground: TooltipHighlightForeground,
  TooltipHighlightForegroundHovered: TooltipHighlightForegroundHovered,
  TooltipHighlightForegroundPressed: TooltipHighlightForegroundPressed,
  TooltipInformationalBackground: TooltipInformationalBackground,
  TooltipInformationalBackgroundHovered: TooltipInformationalBackgroundHovered,
  TooltipInformationalBackgroundPressed: TooltipInformationalBackgroundPressed,
  TooltipInformationalForeground: TooltipInformationalForeground,
  TooltipInformationalForegroundHovered: TooltipInformationalForegroundHovered,
  TooltipInformationalForegroundPressed: TooltipInformationalForegroundPressed,
  WarningBackground: WarningBackground,
  WarningForeground: WarningForeground
};

export { BackgroundElevated, BackgroundOverlay, BackgroundPrimary, BackgroundPrimaryInverted, BackgroundSecondary, BackgroundSecondaryInverted, BackgroundSeparator, BackgroundTertiary, BannerDefaultBackground, BannerDefaultForeground, BannerDefaultIcon, BannerHighlightBackground, BannerHighlightDefaultBackground, BannerHighlightDefaultForeground, BannerHighlightDefaultIcon, BannerHighlightEmphasisBackground, BannerHighlightEmphasisForeground, BannerHighlightEmphasisIcon, BannerHighlightForeground, BannerHighlightIcon, BannerHighlightSubduedBackground, BannerHighlightSubduedBorder, BannerHighlightSubduedDecorator, BannerHighlightSubduedForeground, BannerHighlightSubduedIcon, BannerHighlightSubduedIconBackground, BannerInformationalBackground, BannerInformationalDefaultBackground, BannerInformationalDefaultForeground, BannerInformationalDefaultIcon, BannerInformationalEmphasisBackground, BannerInformationalEmphasisForeground, BannerInformationalEmphasisIcon, BannerInformationalForeground, BannerInformationalIcon, BannerInformationalSubduedBackground, BannerInformationalSubduedBorder, BannerInformationalSubduedDecorator, BannerInformationalSubduedForeground, BannerInformationalSubduedIcon, BannerInformationalSubduedIconBackground, BannerNegativeBackground, BannerNegativeDefaultBackground, BannerNegativeDefaultForeground, BannerNegativeDefaultIcon, BannerNegativeEmphasisBackground, BannerNegativeEmphasisForeground, BannerNegativeEmphasisIcon, BannerNegativeForeground, BannerNegativeIcon, BannerNegativeSubduedBackground, BannerNegativeSubduedBorder, BannerNegativeSubduedDecorator, BannerNegativeSubduedForeground, BannerNegativeSubduedIcon, BannerNegativeSubduedIconBackground, BannerPositiveBackground, BannerPositiveDefaultBackground, BannerPositiveDefaultForeground, BannerPositiveDefaultIcon, BannerPositiveEmphasisBackground, BannerPositiveEmphasisForeground, BannerPositiveEmphasisIcon, BannerPositiveForeground, BannerPositiveIcon, BannerPositiveSubduedBackground, BannerPositiveSubduedBorder, BannerPositiveSubduedDecorator, BannerPositiveSubduedForeground, BannerPositiveSubduedIcon, BannerPositiveSubduedIconBackground, BannerWarningBackground, BannerWarningDefaultBackground, BannerWarningDefaultForeground, BannerWarningDefaultIcon, BannerWarningEmphasisBackground, BannerWarningEmphasisForeground, BannerWarningEmphasisIcon, BannerWarningForeground, BannerWarningIcon, BannerWarningSubduedBackground, BannerWarningSubduedBorder, BannerWarningSubduedDecorator, BannerWarningSubduedForeground, BannerWarningSubduedIcon, BannerWarningSubduedIconBackground, BorderError, BorderErrorDisabled, BorderFocus, BorderPrimary, BorderSecondary, ButtonDefaultToggleForegroundDisabled, ButtonDefaultToggleForegroundOff, ButtonDefaultToggleForegroundOffDisabled, ButtonDefaultToggleForegroundOffHovered, ButtonDefaultToggleForegroundOffPressed, ButtonDestructiveBackground, ButtonDestructiveBackgroundDisabled, ButtonDestructiveBackgroundHovered, ButtonDestructiveBackgroundPressed, ButtonDestructiveForeground, ButtonDestructiveForegroundDisabled, ButtonFabBackground, ButtonFabBackgroundHovered, ButtonFabBackgroundPressed, ButtonFabForeground, ButtonFabForegroundHovered, ButtonFabForegroundPressed, ButtonFlatPrimaryForeground, ButtonFlatPrimaryForegroundDisabled, ButtonFlatPrimaryForegroundHovered, ButtonFlatPrimaryForegroundPressed, ButtonFlatSecondaryForeground, ButtonFlatSecondaryForegroundDisabled, ButtonFlatSecondaryForegroundHovered, ButtonFlatSecondaryForegroundPressed, ButtonFloatingToggleGroupBackgroundColorOff, ButtonLinkForeground, ButtonLinkForegroundDisabled, ButtonLinkForegroundHovered, ButtonLinkForegroundPressed, ButtonPlainForeground, ButtonPlainForegroundDisabled, ButtonPlainForegroundHovered, ButtonPlainForegroundPressed, ButtonPlainToggleForeground, ButtonPlainToggleForegroundDisabled, ButtonPlainToggleForegroundHovered, ButtonPlainToggleForegroundOff, ButtonPlainToggleForegroundOffDisabled, ButtonPlainToggleForegroundOffHovered, ButtonPlainToggleForegroundOffPressed, ButtonPlainToggleForegroundPressed, ButtonPrimaryBackground, ButtonPrimaryBackgroundDisabled, ButtonPrimaryBackgroundHovered, ButtonPrimaryBackgroundPressed, ButtonPrimaryForeground, ButtonPrimaryForegroundDisabled, ButtonPrimaryForegroundHovered, ButtonPrimaryForegroundPressed, ButtonPrimaryToggleBackground, ButtonPrimaryToggleBackgroundDisabled, ButtonPrimaryToggleBackgroundHovered, ButtonPrimaryToggleBackgroundOff, ButtonPrimaryToggleBackgroundOffDisabled, ButtonPrimaryToggleBackgroundOffHovered, ButtonPrimaryToggleBackgroundOffPressed, ButtonPrimaryToggleBackgroundPressed, ButtonPrimaryToggleBorderOff, ButtonPrimaryToggleBorderOffDisabled, ButtonPrimaryToggleBorderOffHovered, ButtonPrimaryToggleBorderOffPressed, ButtonPrimaryToggleBorderOn, ButtonPrimaryToggleBorderOnDisabled, ButtonPrimaryToggleBorderOnHovered, ButtonPrimaryToggleBorderOnPressed, ButtonPrimaryToggleForeground, ButtonPrimaryToggleForegroundDisabled, ButtonPrimaryToggleForegroundHovered, ButtonPrimaryToggleForegroundOff, ButtonPrimaryToggleForegroundOffDisabled, ButtonPrimaryToggleForegroundOffHovered, ButtonPrimaryToggleForegroundOffPressed, ButtonPrimaryToggleForegroundPressed, ButtonPrimaryToggleGroupBackgroundOff, ButtonPrimaryToggleGroupBackgroundOffDisabled, ButtonPrimaryToggleGroupBackgroundOffHovered, ButtonPrimaryToggleGroupBackgroundOffPressed, ButtonPrimaryToggleGroupBackgroundOn, ButtonPrimaryToggleGroupBackgroundOnDisabled, ButtonPrimaryToggleGroupBackgroundOnHovered, ButtonPrimaryToggleGroupBackgroundOnPressed, ButtonPrimaryToggleGroupBorderOff, ButtonPrimaryToggleGroupBorderOffDisabled, ButtonPrimaryToggleGroupBorderOffHovered, ButtonPrimaryToggleGroupBorderOffPressed, ButtonPrimaryToggleGroupBorderOn, ButtonPrimaryToggleGroupBorderOnDisabled, ButtonPrimaryToggleGroupBorderOnHovered, ButtonPrimaryToggleGroupBorderOnPressed, ButtonPrimaryToggleGroupForegroundOff, ButtonPrimaryToggleGroupForegroundOffDisabled, ButtonPrimaryToggleGroupForegroundOffHovered, ButtonPrimaryToggleGroupForegroundOffPressed, ButtonPrimaryToggleGroupForegroundOnDisabled, ButtonSecondaryBackground, ButtonSecondaryBackgroundDisabled, ButtonSecondaryBackgroundHovered, ButtonSecondaryBackgroundPressed, ButtonSecondaryForeground, ButtonSecondaryForegroundDisabled, ButtonSecondaryForegroundHovered, ButtonSecondaryForegroundPressed, ButtonSecondaryToggleBackground, ButtonSecondaryToggleBackgroundDisabled, ButtonSecondaryToggleBackgroundHovered, ButtonSecondaryToggleBackgroundOff, ButtonSecondaryToggleBackgroundOffDisabled, ButtonSecondaryToggleBackgroundOffHovered, ButtonSecondaryToggleBackgroundOffPressed, ButtonSecondaryToggleBackgroundPressed, ButtonSecondaryToggleBorderOff, ButtonSecondaryToggleBorderOffDisabled, ButtonSecondaryToggleBorderOffHovered, ButtonSecondaryToggleBorderOffPressed, ButtonSecondaryToggleBorderOn, ButtonSecondaryToggleBorderOnDisabled, ButtonSecondaryToggleBorderOnHovered, ButtonSecondaryToggleBorderOnPressed, ButtonSecondaryToggleForeground, ButtonSecondaryToggleForegroundDisabled, ButtonSecondaryToggleForegroundHovered, ButtonSecondaryToggleForegroundOff, ButtonSecondaryToggleForegroundOffDisabled, ButtonSecondaryToggleForegroundOffHovered, ButtonSecondaryToggleForegroundOffPressed, ButtonSecondaryToggleForegroundPressed, ButtonSecondaryToggleGroupBackgroundOff, ButtonSecondaryToggleGroupBackgroundOffDisabled, ButtonSecondaryToggleGroupBackgroundOffHovered, ButtonSecondaryToggleGroupBackgroundOffPressed, ButtonSecondaryToggleGroupBackgroundOn, ButtonSecondaryToggleGroupBackgroundOnDisabled, ButtonSecondaryToggleGroupBackgroundOnHovered, ButtonSecondaryToggleGroupBackgroundOnPressed, ButtonSecondaryToggleGroupBorderOff, ButtonSecondaryToggleGroupBorderOffDisabled, ButtonSecondaryToggleGroupBorderOffHovered, ButtonSecondaryToggleGroupBorderOffPressed, ButtonSecondaryToggleGroupBorderOn, ButtonSecondaryToggleGroupBorderOnDisabled, ButtonSecondaryToggleGroupBorderOnHovered, ButtonSecondaryToggleGroupBorderOnPressed, ButtonSecondaryToggleGroupForegroundOff, ButtonSecondaryToggleGroupForegroundOffDisabled, ButtonSecondaryToggleGroupForegroundOffHovered, ButtonSecondaryToggleGroupForegroundOffPressed, ButtonSecondaryToggleGroupForegroundOnDisabled, ButtonTabBackgroundOffDefault, ButtonTabBackgroundOffDisabled, ButtonTabBackgroundOffHovered, ButtonTabBackgroundOffPressed, ButtonTabBackgroundOnDefault, ButtonTabBackgroundOnDisabled, ButtonTabBackgroundOnHovered, ButtonTabBackgroundOnPressed, ButtonTabForegroundOffDefault, ButtonTabForegroundOffDisabled, ButtonTabForegroundOffHovered, ButtonTabForegroundOffPressed, ButtonTabForegroundOnDefault, ButtonTabForegroundOnDisabled, ButtonTabForegroundOnHovered, ButtonTabForegroundOnPressed, ButtonTertiaryBackground, ButtonTertiaryBackgroundDisabled, ButtonTertiaryBackgroundHovered, ButtonTertiaryBackgroundPressed, ButtonTertiaryBorder, ButtonTertiaryBorderDisabled, ButtonTertiaryBorderHovered, ButtonTertiaryBorderPressed, ButtonTertiaryForeground, ButtonTertiaryForegroundDisabled, ButtonTertiaryForegroundHovered, ButtonTertiaryForegroundPressed, ButtonTertiaryToggleBackground, ButtonTertiaryToggleBackgroundDisabled, ButtonTertiaryToggleBackgroundHovered, ButtonTertiaryToggleBackgroundOff, ButtonTertiaryToggleBackgroundOffDisabled, ButtonTertiaryToggleBackgroundOffHovered, ButtonTertiaryToggleBackgroundOffPressed, ButtonTertiaryToggleBackgroundPressed, ButtonTertiaryToggleBorderOff, ButtonTertiaryToggleBorderOffDisabled, ButtonTertiaryToggleBorderOffHovered, ButtonTertiaryToggleBorderOffPressed, ButtonTertiaryToggleBorderOn, ButtonTertiaryToggleBorderOnDisabled, ButtonTertiaryToggleBorderOnHovered, ButtonTertiaryToggleBorderOnPressed, ButtonTertiaryToggleForeground, ButtonTertiaryToggleForegroundDisabled, ButtonTertiaryToggleForegroundHovered, ButtonTertiaryToggleForegroundOff, ButtonTertiaryToggleForegroundOffDisabled, ButtonTertiaryToggleForegroundOffHovered, ButtonTertiaryToggleForegroundOffPressed, ButtonTertiaryToggleForegroundPressed, ButtonTertiaryToggleGroupBackgroundOff, ButtonTertiaryToggleGroupBackgroundOffDisabled, ButtonTertiaryToggleGroupBackgroundOffHovered, ButtonTertiaryToggleGroupBackgroundOffPressed, ButtonTertiaryToggleGroupBackgroundOn, ButtonTertiaryToggleGroupBackgroundOnDisabled, ButtonTertiaryToggleGroupBackgroundOnHovered, ButtonTertiaryToggleGroupBackgroundOnPressed, ButtonTertiaryToggleGroupBorderOff, ButtonTertiaryToggleGroupBorderOffDisabled, ButtonTertiaryToggleGroupBorderOffHovered, ButtonTertiaryToggleGroupBorderOffPressed, ButtonTertiaryToggleGroupBorderOn, ButtonTertiaryToggleGroupBorderOnDisabled, ButtonTertiaryToggleGroupBorderOnHovered, ButtonTertiaryToggleGroupBorderOnPressed, ButtonTertiaryToggleGroupForegroundOff, ButtonTertiaryToggleGroupForegroundOffDisabled, ButtonTertiaryToggleGroupForegroundOffHovered, ButtonTertiaryToggleGroupForegroundOffPressed, ButtonTertiaryToggleGroupForegroundOn, ButtonTertiaryToggleGroupForegroundOnDisabled, ButtonTertiaryToggleGroupForegroundOnHovered, ButtonTertiaryToggleGroupForegroundOnPressed, CardBackgroundDefault, CardBackgroundDisabled, CardBackgroundHovered, CardBackgroundPressed, CardBodyDefault, CardBodyDisabled, CardBodyHovered, CardBodyPressed, CardBorderSelectedDefault, CardBorderSelectedDisabled, CardBorderSelectedError, CardBorderSelectedErrorDisabled, CardBorderSelectedHovered, CardBorderSelectedPressed, CardBorderUnselectedDefault, CardBorderUnselectedDisabled, CardBorderUnselectedError, CardBorderUnselectedErrorDisabled, CardBorderUnselectedHovered, CardBorderUnselectedPressed, CardTitleDefault, CardTitleDisabled, CardTitleHovered, CardTitlePressed, ChatIncomingBackground, ChatIncomingForeground, ChatOutgoingBackground, ChatOutgoingForeground, ColorSemanticsAll, DatePickerDateBorderSelected, DatePickerDateBorderSelectedDisabled, DatePickerDateBorderSelectedHovered, DatePickerDateBorderSelectedPressed, DatePickerDateBorderUnselected, DatePickerDateBorderUnselectedDisabled, DatePickerDateBorderUnselectedHovered, DatePickerDateBorderUnselectedPressed, DatePickerDateForegroundSelected, DatePickerDateForegroundSelectedDisabled, DatePickerDateForegroundSelectedHovered, DatePickerDateForegroundSelectedPressed, DatePickerDateForegroundUnselected, DatePickerDateForegroundUnselectedDisabled, DatePickerDateForegroundUnselectedHovered, DatePickerDateForegroundUnselectedPressed, DatePickerDateSelectedBackground, DatePickerDateSelectedBackgroundDisabled, DatePickerDateSelectedBackgroundHovered, DatePickerDateSelectedBackgroundPressed, DatePickerDateSelectedIndicatorDisabled, DatePickerDateSelectedIndicatorPrimary, DatePickerDateSelectedIndicatorSecondary, DatePickerDateUnselectedBackground, DatePickerDateUnselectedBackgroundDisabled, DatePickerDateUnselectedBackgroundHovered, DatePickerDateUnselectedBackgroundPressed, DatePickerDateUnselectedIndicatorDisabled, DatePickerDateUnselectedIndicatorPrimary, DatePickerDateUnselectedIndicatorSecondary, DatePickerRangeBorderSelected, DatePickerRangeBorderSelectedDisabled, DatePickerRangeBorderSelectedHovered, DatePickerRangeBorderSelectedPressed, DatePickerRangeBorderUnselected, DatePickerRangeBorderUnselectedDisabled, DatePickerRangeBorderUnselectedHovered, DatePickerRangeBorderUnselectedPressed, DatePickerRangeForegroundSelected, DatePickerRangeForegroundSelectedDisabled, DatePickerRangeForegroundSelectedHovered, DatePickerRangeForegroundSelectedPressed, DatePickerRangeForegroundUnselected, DatePickerRangeForegroundUnselectedDisabled, DatePickerRangeForegroundUnselectedHovered, DatePickerRangeForegroundUnselectedPressed, DatePickerRangeSelectedBackground, DatePickerRangeSelectedBackgroundDisabled, DatePickerRangeSelectedBackgroundHovered, DatePickerRangeSelectedBackgroundPressed, DatePickerRangeSelectedIndicatorDisabled, DatePickerRangeSelectedIndicatorPrimary, DatePickerRangeSelectedIndicatorSecondary, DatePickerRangeUnselectedBackground, DatePickerRangeUnselectedBackgroundDisabled, DatePickerRangeUnselectedBackgroundHovered, DatePickerRangeUnselectedBackgroundPressed, DatePickerTodayBorderSelected, FieldsBackgroundActive, FieldsBackgroundDisabled, FieldsBackgroundError, FieldsBackgroundInactive, FieldsBorderActive, FieldsBorderDisabled, FieldsBorderError, FieldsBorderInactive, FieldsForegroundActive, FieldsForegroundDisabled, FieldsForegroundError, FieldsForegroundInactive, FieldsForegroundPlaceholder, FieldsIconDropdown, FieldsIconSearch, FieldsInputBackgroundDisabled, FieldsInputBorder, FieldsInputBorderError, GlobalPrimary, GlobalSecondary, ListCellContainerBackgroundDefault, ListCellContainerBackgroundHovered, ListCellContainerBackgroundPressed, ListCellContainerBackgroundUnread, ListCellContainerBackgroundUnreadHovered, ListCellContainerBackgroundUnreadPressed, ListCellIconToggledOff, ListCellIconToggledOn, LoadingDefault, MenuItemBackground, MenuItemBackgroundDisabled, MenuItemBackgroundHovered, MenuItemBackgroundPressed, MenuItemForeground, MenuItemForegroundDisabled, MenuItemForegroundHovered, MenuItemForegroundPressed, OverlayBackgroundDefault, OverlayLoadingDefault, PageBackgroundSecondary, PageBackgroundTertiary, PaginationNumberedSelectedBackground, PaginationNumberedSelectedBackgroundDisabled, PaginationNumberedSelectedBackgroundHovered, PaginationNumberedSelectedBackgroundPressed, PaginationNumberedSelectedBorder, PaginationNumberedSelectedBorderDisabled, PaginationNumberedSelectedBorderHovered, PaginationNumberedSelectedBorderPressed, PaginationNumberedSelectedForeground, PaginationNumberedSelectedForegroundDisabled, PaginationNumberedSelectedForegroundHovered, PaginationNumberedSelectedForegroundPressed, PaginationNumberedUnselectedBackground, PaginationNumberedUnselectedBackgroundDisabled, PaginationNumberedUnselectedBackgroundHovered, PaginationNumberedUnselectedBackgroundPressed, PaginationNumberedUnselectedBorder, PaginationNumberedUnselectedBorderDisabled, PaginationNumberedUnselectedBorderHovered, PaginationNumberedUnselectedBorderPressed, PaginationNumberedUnselectedForeground, PaginationNumberedUnselectedForegroundDisabled, PaginationNumberedUnselectedForegroundHovered, PaginationNumberedUnselectedForegroundPressed, PaginationSelectedDark, PaginationSelectedLight, PaginationSelectedPrimary, PaginationUnselectedDark, PaginationUnselectedLight, PaginationUnselectedPrimary, QuantityStepperFloatingCollapsedSelectedBackgroundDefault, QuantityStepperFloatingCollapsedSelectedBackgroundDisabled, QuantityStepperFloatingCollapsedSelectedBackgroundHover, QuantityStepperFloatingCollapsedSelectedBackgroundPressed, QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDefault, QuantityStepperFloatingCollapsedSelectedForegroundPrimaryDisabled, QuantityStepperFloatingCollapsedSelectedForegroundPrimaryHover, QuantityStepperFloatingCollapsedSelectedForegroundPrimaryPressed, QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDefault, QuantityStepperFloatingCollapsedSelectedForegroundSecondaryDisabled, QuantityStepperFloatingCollapsedSelectedForegroundSecondaryHover, QuantityStepperFloatingCollapsedSelectedForegroundSecondaryPressed, QuantityStepperFloatingCollapsedUnselectedBackgroundDefault, QuantityStepperFloatingCollapsedUnselectedBackgroundDisabled, QuantityStepperFloatingCollapsedUnselectedBackgroundHover, QuantityStepperFloatingCollapsedUnselectedBackgroundPressed, QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDefault, QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryDisabled, QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryHover, QuantityStepperFloatingCollapsedUnselectedForegroundPrimaryPressed, QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDefault, QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryDisabled, QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryHover, QuantityStepperFloatingCollapsedUnselectedForegroundSecondaryPressed, QuantityStepperFloatingExpandedBackgroundDefault, QuantityStepperFloatingExpandedBackgroundDisabled, QuantityStepperFloatingExpandedBackgroundHover, QuantityStepperFloatingExpandedBackgroundPressed, QuantityStepperFloatingExpandedForegroundPrimaryDefault, QuantityStepperFloatingExpandedForegroundPrimaryDisabled, QuantityStepperFloatingExpandedForegroundPrimaryHover, QuantityStepperFloatingExpandedForegroundPrimaryPressed, QuantityStepperFloatingExpandedForegroundSecondaryDefault, QuantityStepperFloatingExpandedForegroundSecondaryDisabled, QuantityStepperFloatingExpandedForegroundSecondaryHover, QuantityStepperFloatingExpandedForegroundSecondaryPressed, SliderIcon, SliderIconDisabled, SliderKnobBackground, SliderKnobBackgroundDisabled, SliderKnobBackgroundHovered, SliderKnobBackgroundPressed, SliderTextOff, SliderTextOffDisabled, SliderTextOn, SliderTextOnDisabled, SliderTrackBackgroundOff, SliderTrackBackgroundOffDisabled, SliderTrackBackgroundOn, SliderTrackBackgroundOnDisabled, SwitchBackgroundOff, SwitchBackgroundOffDisabled, SwitchBackgroundOn, SwitchBackgroundOnDisabled, SwitchBorderOff, SwitchBorderOffDisabled, SwitchBorderOn, SwitchBorderOnDisabled, SwitchForegroundOff, SwitchForegroundOffDisabled, SwitchForegroundOn, SwitchForegroundOnDisabled, SwitchThumbOff, SwitchThumbOffDisabled, SwitchThumbOn, SwitchThumbOnDisabled, SwitchTrackOff, SwitchTrackOffDisabled, SwitchTrackOn, SwitchTrackOnDisabled, TagDefaultBackground, TagDefaultBorder, TagDefaultForeground, TagDefaultIcon, TagHighlightBackground, TagHighlightBorder, TagHighlightDefaultBackground, TagHighlightDefaultBorder, TagHighlightDefaultForeground, TagHighlightDefaultIcon, TagHighlightEmphasisBackground, TagHighlightEmphasisBorder, TagHighlightEmphasisForeground, TagHighlightEmphasisIcon, TagHighlightForeground, TagHighlightIcon, TagHighlightSubduedBackground, TagHighlightSubduedBorder, TagHighlightSubduedForeground, TagHighlightSubduedIcon, TagInformationalBackground, TagInformationalBorder, TagInformationalDefaultBackground, TagInformationalDefaultBorder, TagInformationalDefaultForeground, TagInformationalDefaultIcon, TagInformationalEmphasisBackground, TagInformationalEmphasisBorder, TagInformationalEmphasisForeground, TagInformationalEmphasisIcon, TagInformationalForeground, TagInformationalIcon, TagInformationalSubduedBackground, TagInformationalSubduedBorder, TagInformationalSubduedForeground, TagInformationalSubduedIcon, TagNegativeBackground, TagNegativeBorder, TagNegativeDefaultBackground, TagNegativeDefaultBorder, TagNegativeDefaultForeground, TagNegativeDefaultIcon, TagNegativeEmphasisBackground, TagNegativeEmphasisBorder, TagNegativeEmphasisForeground, TagNegativeEmphasisIcon, TagNegativeForeground, TagNegativeIcon, TagNegativeSubduedBackground, TagNegativeSubduedBorder, TagNegativeSubduedForeground, TagNegativeSubduedIcon, TagPositiveBackground, TagPositiveBorder, TagPositiveDefaultBackground, TagPositiveDefaultBorder, TagPositiveDefaultForeground, TagPositiveDefaultIcon, TagPositiveEmphasisBackground, TagPositiveEmphasisBorder, TagPositiveEmphasisForeground, TagPositiveEmphasisIcon, TagPositiveForeground, TagPositiveIcon, TagPositiveSubduedBackground, TagPositiveSubduedBorder, TagPositiveSubduedForeground, TagPositiveSubduedIcon, TagWarningBackground, TagWarningBorder, TagWarningDefaultBackground, TagWarningDefaultBorder, TagWarningDefaultForeground, TagWarningDefaultIcon, TagWarningEmphasisBackground, TagWarningEmphasisBorder, TagWarningEmphasisForeground, TagWarningEmphasisIcon, TagWarningForeground, TagWarningIcon, TagWarningSubduedBackground, TagWarningSubduedBorder, TagWarningSubduedForeground, TagWarningSubduedIcon, TextAccentedPrimary, TextAccentedSecondary, TextAction, TextCallout, TextDisabled, TextError, TextHighlight, TextPositive, TextPrimary, TextPrimaryOnDark, TextSecondary, TextSecondaryOnDark, TextSelected, TextTertiary, TextTooltip, TextWarning, TimelineTrackBackgroundOff, TimelineTrackBackgroundOn, TimelineTrackForegroundOff, TimelineTrackForegroundOn, TimelineTrackShimmer, ToastInformationalAction, ToastInformationalActionDisabled, ToastInformationalActionHovered, ToastInformationalActionPressed, ToastInformationalBackground, ToastInformationalForeground, ToggleBackgroundOff, ToggleBackgroundOffDisabled, ToggleBackgroundOn, ToggleBackgroundOnDisabled, ToggleBorderOff, ToggleBorderOffDisabled, ToggleBorderOn, ToggleBorderOnDisabled, ToggleForegroundOff, ToggleForegroundOffDisabled, ToggleForegroundOn, ToggleForegroundOnDisabled, TooltipHighlightBackground, TooltipHighlightBackgroundHovered, TooltipHighlightBackgroundPressed, TooltipHighlightForeground, TooltipHighlightForegroundHovered, TooltipHighlightForegroundPressed, TooltipInformationalBackground, TooltipInformationalBackgroundHovered, TooltipInformationalBackgroundPressed, TooltipInformationalForeground, TooltipInformationalForegroundHovered, TooltipInformationalForegroundPressed, WarningBackground, WarningForeground, ColorSemanticsAll as default };
